/**
 * Aircraft Database
 * 321 Total Aircraft:
 * - 187 Real Purchasable Aircraft (61 regional, 50 narrowbody, 45 widebody, 28 bizjet, 3 heavy)
 * - 134 Collectibles (Rare 53, Relic 21, Anomalous 27, Legendary 32, Mythic 1)
 *
 * Categories (for fleet unlock system):
 * - Regional: E170, E175, E190, E195, CRJ700, CRJ900, A220-300, ATR, Dash 8, etc.
 * - Narrowbody: A319, A320, A320neo, A321, A321XLR, B737 family, B757, etc.
 * - Widebody: A330, A350, B767-300ER, B777, B787, etc.
 * - Heavy: A380, B747-8, 747-400 variants (top-tier unlock required)
 * - Bizjet: Business jets (Gulfstream, Bombardier, Dassault, etc.)
 * - Collectible: EOS rewards only (not purchasable)
 *
 * Weight fields (all in LBS):
 * - oew: Operating Empty Weight
 * - mtow: Maximum Takeoff Weight
 * - mlw: Maximum Landing Weight
 */

export const AIRCRAFT_DATABASE = {
  // ============================================================================
  // REGIONAL (7 aircraft)
  // ============================================================================
  
  "Embraer-E170": {
    model: "Embraer E170",
    manufacturer: "Embraer",
    category: "regional",
    capacity: 72,
    range: 2100,
    cruiseSpeed: 470,
    fuelBurn: 1800,
    purchasePrice: 23000000,
    leasePrice: 180000,
    operatingCost: 3000,
    maintenanceCost: 1200,
    aCheckCost: 45000,
    cCheckCost: 850000,
    noiseCategory: 4,
    etops: false,
    minRunway: 5500,
    crew: { captain: 1, fo: 1, fa: 2 },
    image: "./aircraft/Embraer-E170.png",
    tier: 1,
    // Weights in LBS
    oew: 44000,
    mtow: 79344,
    mlw: 72312,
  },
  
  "Embraer-E175": {
    model: "Embraer E175",
    manufacturer: "Embraer",
    category: "regional",
    capacity: 78,
    range: 2200,
    cruiseSpeed: 481,
    fuelBurn: 1900,
    purchasePrice: 27000000,
    leasePrice: 210000,
    operatingCost: 3100,
    maintenanceCost: 1250,
    aCheckCost: 48000,
    cCheckCost: 900000,
    noiseCategory: 4,
    etops: false,
    minRunway: 5800,
    crew: { captain: 1, fo: 1, fa: 2 },
    image: "./aircraft/Embraer-E175.png",
    tier: 1,
    // Weights in LBS
    oew: 44800,
    mtow: 82673,
    mlw: 74957,
  },
  
  "Embraer-E190": {
    model: "Embraer E190",
    manufacturer: "Embraer",
    category: "regional",
    capacity: 100,
    range: 2450,
    cruiseSpeed: 470,
    fuelBurn: 2100,
    purchasePrice: 32000000,
    leasePrice: 250000,
    operatingCost: 3400,
    maintenanceCost: 1400,
    aCheckCost: 52000,
    cCheckCost: 950000,
    noiseCategory: 4,
    etops: false,
    minRunway: 6000,
    crew: { captain: 1, fo: 1, fa: 3 },
    image: "./aircraft/Embraer-E190.png",
    tier: 1,
    // Weights in LBS
    oew: 61509,
    mtow: 105359,
    mlw: 94799,
  },
  
  "Embraer-E195": {
    model: "Embraer E195",
    manufacturer: "Embraer",
    category: "regional",
    capacity: 120,
    range: 2300,
    cruiseSpeed: 470,
    fuelBurn: 2250,
    purchasePrice: 35000000,
    leasePrice: 275000,
    operatingCost: 3600,
    maintenanceCost: 1500,
    aCheckCost: 55000,
    cCheckCost: 1000000,
    noiseCategory: 4,
    etops: false,
    minRunway: 6200,
    crew: { captain: 1, fo: 1, fa: 3 },
    image: "./aircraft/Embraer-E195.png",
    tier: 1,
    // Weights in LBS
    oew: 63052,
    mtow: 111332,
    mlw: 100310,
  },
  
  "CRJ700": {
    model: "CRJ700",
    manufacturer: "Bombardier",
    category: "regional",
    capacity: 70,
    range: 1650,
    cruiseSpeed: 447,
    fuelBurn: 1750,
    purchasePrice: 24000000,
    leasePrice: 185000,
    operatingCost: 2900,
    maintenanceCost: 1150,
    aCheckCost: 42000,
    cCheckCost: 800000,
    noiseCategory: 4,
    etops: false,
    minRunway: 5500,
    crew: { captain: 1, fo: 1, fa: 2 },
    image: "./aircraft/crj700.png",
    tier: 1,
    // Weights in LBS
    oew: 44245,
    mtow: 72750,
    mlw: 67000,
  },
  
  "CRJ900": {
    model: "CRJ900",
    manufacturer: "Bombardier",
    category: "regional",
    capacity: 90,
    range: 1550,
    cruiseSpeed: 447,
    fuelBurn: 1950,
    purchasePrice: 28000000,
    leasePrice: 220000,
    operatingCost: 3200,
    maintenanceCost: 1300,
    aCheckCost: 46000,
    cCheckCost: 875000,
    noiseCategory: 4,
    etops: false,
    minRunway: 6000,
    crew: { captain: 1, fo: 1, fa: 2 },
    image: "./aircraft/crj900.png",
    tier: 1,
    // Weights in LBS
    oew: 47950,
    mtow: 80500,
    mlw: 74000,
  },
  
  "A220-300": {
    model: "A220-300",
    manufacturer: "Airbus",
    category: "regional",
    capacity: 140,
    range: 3400,
    cruiseSpeed: 470,
    fuelBurn: 2200,
    purchasePrice: 45000000,
    leasePrice: 350000,
    operatingCost: 3800,
    maintenanceCost: 1600,
    aCheckCost: 60000,
    cCheckCost: 1100000,
    noiseCategory: 4,
    etops: true,
    minRunway: 5500,
    crew: { captain: 1, fo: 1, fa: 3 },
    image: "./aircraft/a220-300.png",
    tier: 2,
    // Weights in LBS
    oew: 79700,
    mtow: 149900,
    mlw: 132500,
  },
  
  // ============================================================================
  // NARROWBODY (12 aircraft)
  // ============================================================================
  
  "A319": {
    model: "A319",
    manufacturer: "Airbus",
    category: "narrowbody",
    capacity: 140,
    range: 3700,
    cruiseSpeed: 447,
    fuelBurn: 2400,
    purchasePrice: 48000000,
    leasePrice: 375000,
    operatingCost: 4200,
    maintenanceCost: 1800,
    aCheckCost: 65000,
    cCheckCost: 1200000,
    noiseCategory: 4,
    etops: true,
    minRunway: 6000,
    crew: { captain: 1, fo: 1, fa: 3 },
    image: "./aircraft/a319.png",
    tier: 2,
    // Weights in LBS
    oew: 88000,
    mtow: 141100,
    mlw: 130000,
  },
  
  "A320": {
    model: "A320",
    manufacturer: "Airbus",
    category: "narrowbody",
    capacity: 165,
    range: 3300,
    cruiseSpeed: 447,
    fuelBurn: 2700,
    purchasePrice: 52000000,
    leasePrice: 400000,
    operatingCost: 4500,
    maintenanceCost: 1900,
    aCheckCost: 70000,
    cCheckCost: 1300000,
    noiseCategory: 4,
    etops: true,
    minRunway: 6500,
    crew: { captain: 1, fo: 1, fa: 4 },
    image: "./aircraft/a320.png",
    tier: 2,
    // Weights in LBS
    oew: 93900,
    mtow: 154300,
    mlw: 142200,
  },
  
  "A320neo": {
    model: "A320neo",
    manufacturer: "Airbus",
    category: "narrowbody",
    capacity: 165,
    range: 3500,
    cruiseSpeed: 450,
    fuelBurn: 2400,
    purchasePrice: 58000000,
    leasePrice: 450000,
    operatingCost: 4200,
    maintenanceCost: 2000,
    aCheckCost: 75000,
    cCheckCost: 1400000,
    noiseCategory: 4,
    etops: true,
    minRunway: 6200,
    crew: { captain: 1, fo: 1, fa: 4 },
    image: "./aircraft/a320neo.png",
    tier: 2,
    // Weights in LBS
    oew: 93900,
    mtow: 174200,
    mlw: 148600,
  },
  
  "A321": {
    model: "A321",
    manufacturer: "Airbus",
    category: "narrowbody",
    capacity: 200,
    range: 3200,
    cruiseSpeed: 447,
    fuelBurn: 3000,
    purchasePrice: 62000000,
    leasePrice: 480000,
    operatingCost: 5000,
    maintenanceCost: 2100,
    aCheckCost: 80000,
    cCheckCost: 1500000,
    noiseCategory: 4,
    etops: true,
    minRunway: 7000,
    crew: { captain: 1, fo: 1, fa: 4 },
    image: "./aircraft/a321.png",
    tier: 2,
    // Weights in LBS
    oew: 106000,
    mtow: 196200,
    mlw: 170600,
  },
  
  "A321XLR": {
    model: "A321XLR",
    manufacturer: "Airbus",
    category: "narrowbody",
    capacity: 180,
    range: 4700,
    cruiseSpeed: 450,
    fuelBurn: 2800,
    purchasePrice: 75000000,
    leasePrice: 580000,
    operatingCost: 4800,
    maintenanceCost: 2200,
    aCheckCost: 85000,
    cCheckCost: 1600000,
    noiseCategory: 4,
    etops: true,
    minRunway: 6800,
    crew: { captain: 1, fo: 1, fa: 4 },
    image: "./aircraft/a321xlr.png",
    tier: 3,
    // Weights in LBS
    oew: 114600,
    mtow: 227000,
    mlw: 181200,
  },
  
  "B737-700": {
    model: "737-700",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 140,
    range: 3400,
    cruiseSpeed: 453,
    fuelBurn: 2300,
    purchasePrice: 46000000,
    leasePrice: 360000,
    operatingCost: 4000,
    maintenanceCost: 1750,
    aCheckCost: 62000,
    cCheckCost: 1150000,
    noiseCategory: 4,
    etops: true,
    minRunway: 5800,
    crew: { captain: 1, fo: 1, fa: 3 },
    image: "./aircraft/b737-700.png",
    tier: 2,
    // Weights in LBS
    oew: 83000,
    mtow: 146000,
    mlw: 128000,
  },
  
  "B737-800": {
    model: "737-800",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 175,
    range: 3100,
    cruiseSpeed: 453,
    fuelBurn: 2600,
    purchasePrice: 54000000,
    leasePrice: 420000,
    operatingCost: 4400,
    maintenanceCost: 1850,
    aCheckCost: 68000,
    cCheckCost: 1250000,
    noiseCategory: 4,
    etops: true,
    minRunway: 6500,
    crew: { captain: 1, fo: 1, fa: 4 },
    image: "./aircraft/b737-800.png",
    tier: 2,
    // Weights in LBS
    oew: 91300,
    mtow: 174200,
    mlw: 146300,
  },
  
  "B737-900ER": {
    model: "737-900ER",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 190,
    range: 2950,
    cruiseSpeed: 453,
    fuelBurn: 2800,
    purchasePrice: 58000000,
    leasePrice: 450000,
    operatingCost: 4700,
    maintenanceCost: 1950,
    aCheckCost: 72000,
    cCheckCost: 1350000,
    noiseCategory: 4,
    etops: true,
    minRunway: 7200,
    crew: { captain: 1, fo: 1, fa: 4 },
    image: "./aircraft/b737-900er.png",
    tier: 2,
    // Weights in LBS
    oew: 98500,
    mtow: 187700,
    mlw: 157300,
  },
  
  "B737MAX8": {
    model: "737 MAX 8",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 178,
    range: 3550,
    cruiseSpeed: 453,
    fuelBurn: 2350,
    purchasePrice: 65000000,
    leasePrice: 500000,
    operatingCost: 4100,
    maintenanceCost: 2000,
    aCheckCost: 75000,
    cCheckCost: 1400000,
    noiseCategory: 4,
    etops: true,
    minRunway: 6300,
    crew: { captain: 1, fo: 1, fa: 4 },
    image: "./aircraft/b737max8.png",
    tier: 2,
    // Weights in LBS
    oew: 99360,
    mtow: 182200,
    mlw: 152800,
  },
  
  "B737MAX9": {
    model: "737 MAX 9",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 193,
    range: 3550,
    cruiseSpeed: 453,
    fuelBurn: 2500,
    purchasePrice: 70000000,
    leasePrice: 540000,
    operatingCost: 4400,
    maintenanceCost: 2100,
    aCheckCost: 78000,
    cCheckCost: 1450000,
    noiseCategory: 4,
    etops: true,
    minRunway: 6800,
    crew: { captain: 1, fo: 1, fa: 4 },
    image: "./aircraft/b737max9.png",
    tier: 2,
    // Weights in LBS
    oew: 101000,
    mtow: 194700,
    mlw: 163500,
  },
  
  "B757-200": {
    model: "757-200",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 200,
    range: 3900,
    cruiseSpeed: 458,
    fuelBurn: 3200,
    purchasePrice: 40000000,
    leasePrice: 320000,
    operatingCost: 5200,
    maintenanceCost: 2200,
    aCheckCost: 85000,
    cCheckCost: 1600000,
    noiseCategory: 3,
    etops: true,
    minRunway: 6000,
    crew: { captain: 1, fo: 1, fa: 4 },
    image: "./aircraft/b757-200.png",
    tier: 2,
    // Weights in LBS
    oew: 127520,
    mtow: 255000,
    mlw: 210000,
  },
  
  "B757-300": {
    model: "757-300",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 243,
    range: 3400,
    cruiseSpeed: 458,
    fuelBurn: 3500,
    purchasePrice: 45000000,
    leasePrice: 360000,
    operatingCost: 5600,
    maintenanceCost: 2400,
    aCheckCost: 90000,
    cCheckCost: 1700000,
    noiseCategory: 3,
    etops: true,
    minRunway: 7500,
    crew: { captain: 1, fo: 1, fa: 5 },
    image: "./aircraft/b757-300.png",
    tier: 2,
    // Weights in LBS
    oew: 141900,
    mtow: 270000,
    mlw: 224000,
  },
  
  // ============================================================================
  // WIDEBODY (13 aircraft)
  // ============================================================================
  
  "A330-200": {
    model: "A330-200",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 250,
    range: 7250,
    cruiseSpeed: 470,
    fuelBurn: 5500,
    purchasePrice: 120000000,
    leasePrice: 950000,
    operatingCost: 8500,
    maintenanceCost: 3500,
    aCheckCost: 150000,
    cCheckCost: 2800000,
    noiseCategory: 4,
    etops: true,
    minRunway: 8500,
    crew: { captain: 1, fo: 1, fa: 8 },
    image: "./aircraft/a330-200.png",
    tier: 3,
    // Weights in LBS
    oew: 264600,
    mtow: 509000,
    mlw: 397000,
  },
  
  "A330-300": {
    model: "A330-300",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 295,
    range: 6350,
    cruiseSpeed: 470,
    fuelBurn: 5900,
    purchasePrice: 135000000,
    leasePrice: 1050000,
    operatingCost: 9200,
    maintenanceCost: 3700,
    aCheckCost: 160000,
    cCheckCost: 3000000,
    noiseCategory: 4,
    etops: true,
    minRunway: 8800,
    crew: { captain: 1, fo: 1, fa: 9 },
    image: "./aircraft/a330-300.png",
    tier: 3,
    // Weights in LBS
    oew: 277000,
    mtow: 515700,
    mlw: 412300,
  },
  
  "A330-900neo": {
    model: "A330-900neo",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 287,
    range: 7200,
    cruiseSpeed: 470,
    fuelBurn: 5200,
    purchasePrice: 160000000,
    leasePrice: 1250000,
    operatingCost: 8200,
    maintenanceCost: 3800,
    aCheckCost: 170000,
    cCheckCost: 3200000,
    noiseCategory: 4,
    etops: true,
    minRunway: 8200,
    crew: { captain: 1, fo: 1, fa: 9 },
    image: "./aircraft/a330-900neo.png",
    tier: 4,
    // Weights in LBS
    oew: 282500,
    mtow: 533500,
    mlw: 421100,
  },
  
  "A350-900": {
    model: "A350-900",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 315,
    range: 8100,
    cruiseSpeed: 488,
    fuelBurn: 5800,
    purchasePrice: 185000000,
    leasePrice: 1450000,
    operatingCost: 9000,
    maintenanceCost: 4000,
    aCheckCost: 180000,
    cCheckCost: 3500000,
    noiseCategory: 4,
    etops: true,
    minRunway: 8500,
    crew: { captain: 1, fo: 1, fa: 10 },
    image: "./aircraft/a350-900.png",
    tier: 4,
    // Weights in LBS
    oew: 283500,
    mtow: 617300,
    mlw: 460500,
  },
  
  "A350-1000": {
    model: "A350-1000",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 366,
    range: 8700,
    cruiseSpeed: 488,
    fuelBurn: 6300,
    purchasePrice: 210000000,
    leasePrice: 1650000,
    operatingCost: 9800,
    maintenanceCost: 4300,
    aCheckCost: 195000,
    cCheckCost: 3800000,
    noiseCategory: 4,
    etops: true,
    minRunway: 9000,
    crew: { captain: 1, fo: 1, fa: 11 },
    image: "./aircraft/a350-1000.png",
    tier: 4,
    // Weights in LBS
    oew: 306600,
    mtow: 683400,
    mlw: 502700,
  },
  
  "A380": {
    model: "A380-800",
    manufacturer: "Airbus",
    category: "heavy",
    capacity: 525,
    range: 8200,
    cruiseSpeed: 480,
    fuelBurn: 11000,
    purchasePrice: 375000000,
    leasePrice: 2900000,
    operatingCost: 16000,
    maintenanceCost: 7500,
    aCheckCost: 350000,
    cCheckCost: 6500000,
    noiseCategory: 4,
    etops: true,
    minRunway: 9500,
    crew: { captain: 1, fo: 1, fa: 16 },
    image: "./aircraft/a380.png",
    tier: 5,
    triggersRareRoll: true,
    // Weights in LBS
    oew: 610700,
    mtow: 1234600,
    mlw: 869700,
  },
  
  "B747-8": {
    model: "747-8",
    manufacturer: "Boeing",
    category: "heavy",
    capacity: 410,
    range: 8000,
    cruiseSpeed: 490,
    fuelBurn: 10200,
    purchasePrice: 320000000,
    leasePrice: 2500000,
    operatingCost: 14500,
    maintenanceCost: 6800,
    aCheckCost: 320000,
    cCheckCost: 6000000,
    noiseCategory: 4,
    etops: true,
    minRunway: 10000,
    crew: { captain: 1, fo: 1, fa: 14 },
    image: "./aircraft/b747-8.png",
    tier: 5,
    // Weights in LBS
    oew: 485300,
    mtow: 975000,
    mlw: 688000,
  },
  
  "B767-300ER": {
    model: "767-300ER",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 218,
    range: 5980,
    cruiseSpeed: 460,
    fuelBurn: 5000,
    purchasePrice: 95000000,
    leasePrice: 750000,
    operatingCost: 7800,
    maintenanceCost: 3200,
    aCheckCost: 130000,
    cCheckCost: 2500000,
    noiseCategory: 3,
    etops: true,
    minRunway: 8000,
    crew: { captain: 1, fo: 1, fa: 7 },
    image: "./aircraft/b767-300er.png",
    tier: 3,
    // Weights in LBS
    oew: 198400,
    mtow: 412000,
    mlw: 320000,
  },
  
  "B777-200ER": {
    model: "777-200ER",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 314,
    range: 7700,
    cruiseSpeed: 490,
    fuelBurn: 6800,
    purchasePrice: 165000000,
    leasePrice: 1300000,
    operatingCost: 10500,
    maintenanceCost: 4200,
    aCheckCost: 175000,
    cCheckCost: 3300000,
    noiseCategory: 4,
    etops: true,
    minRunway: 9500,
    crew: { captain: 1, fo: 1, fa: 10 },
    image: "./aircraft/b777-200er.png",
    tier: 4,
    // Weights in LBS
    oew: 304500,
    mtow: 656000,
    mlw: 470000,
  },
  
  "B777-300ER": {
    model: "777-300ER",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 386,
    range: 7370,
    cruiseSpeed: 490,
    fuelBurn: 7500,
    purchasePrice: 200000000,
    leasePrice: 1550000,
    operatingCost: 11500,
    maintenanceCost: 4600,
    aCheckCost: 190000,
    cCheckCost: 3600000,
    noiseCategory: 4,
    etops: true,
    minRunway: 10000,
    crew: { captain: 1, fo: 1, fa: 12 },
    image: "./aircraft/b777-300er.png",
    tier: 4,
    // Weights in LBS
    oew: 366100,
    mtow: 775000,
    mlw: 554000,
  },
  
  "B787-8": {
    model: "787-8",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 242,
    range: 7355,
    cruiseSpeed: 488,
    fuelBurn: 5100,
    purchasePrice: 140000000,
    leasePrice: 1100000,
    operatingCost: 8000,
    maintenanceCost: 3600,
    aCheckCost: 155000,
    cCheckCost: 2900000,
    noiseCategory: 4,
    etops: true,
    minRunway: 8000,
    crew: { captain: 1, fo: 1, fa: 8 },
    image: "./aircraft/b787-8.png",
    tier: 3,
    // Weights in LBS
    oew: 264500,
    mtow: 502500,
    mlw: 380000,
  },
  
  "B787-9": {
    model: "787-9",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 290,
    range: 7635,
    cruiseSpeed: 488,
    fuelBurn: 5400,
    purchasePrice: 160000000,
    leasePrice: 1250000,
    operatingCost: 8500,
    maintenanceCost: 3800,
    aCheckCost: 165000,
    cCheckCost: 3100000,
    noiseCategory: 4,
    etops: true,
    minRunway: 8500,
    crew: { captain: 1, fo: 1, fa: 9 },
    image: "./aircraft/b787-9.png",
    tier: 4,
    // Weights in LBS
    oew: 282500,
    mtow: 560000,
    mlw: 425000,
  },
  
  "B787-10": {
    model: "787-10",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 330,
    range: 6430,
    cruiseSpeed: 488,
    fuelBurn: 5700,
    purchasePrice: 175000000,
    leasePrice: 1350000,
    operatingCost: 9000,
    maintenanceCost: 4000,
    aCheckCost: 175000,
    cCheckCost: 3300000,
    noiseCategory: 4,
    etops: true,
    minRunway: 9000,
    crew: { captain: 1, fo: 1, fa: 10 },
    image: "./aircraft/b787-10.png",
    tier: 4,
    // Weights in LBS
    oew: 298700,
    mtow: 560000,
    mlw: 445000,
  },
  
  // ============================================================================
  // EOS COLLECTIBLES (92 aircraft) - Only available via EOS + A380 rolls
  // Organized by rarity tier: RARE (79.9%), RELIC (10%), ANOMALOUS (5%),
  // LEGENDARY (5%), MYTHIC (0.1%)
  // ============================================================================

  // --------------------------------------------------------------------------
  // RARE TIER (79.9% roll chance) - 20 Aircraft
  // --------------------------------------------------------------------------

  "747-9": {
    model: "747-9",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "The freighter's revenge.",
    capacity: 450,
    range: 8500,
    cruiseSpeed: 510,
    fuelBurn: 11000,
    purchasePrice: 420000000,
    leasePrice: null,
    operatingCost: 18000,
    tier: 5,
    image: "./aircraft/collectibles/rare/747-9.png",
  },
  "747-10": {
    model: "747-10",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "They stretched it again.",
    capacity: 480,
    range: 9000,
    cruiseSpeed: 515,
    fuelBurn: 12000,
    purchasePrice: 450000000,
    leasePrice: null,
    operatingCost: 19000,
    tier: 5,
    image: "./aircraft/collectibles/rare/747-10.png",
  },
  "777-400": {
    model: "777-400",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "The workhorse evolved.",
    capacity: 380,
    range: 8200,
    cruiseSpeed: 512,
    fuelBurn: 8500,
    purchasePrice: 380000000,
    leasePrice: null,
    operatingCost: 15000,
    tier: 5,
    image: "./aircraft/collectibles/rare/777-400.png",
  },
  "777-500": {
    model: "777-500",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "Transatlantic dominator.",
    capacity: 400,
    range: 8800,
    cruiseSpeed: 518,
    fuelBurn: 9000,
    purchasePrice: 400000000,
    leasePrice: null,
    operatingCost: 16000,
    tier: 5,
    image: "./aircraft/collectibles/rare/777-500.png",
  },
  "777-xr8-ed": {
    model: "777-XR8-ED",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "Extended definition. Boeing showing off.",
    capacity: 420,
    range: 9500,
    cruiseSpeed: 525,
    fuelBurn: 8800,
    purchasePrice: 440000000,
    leasePrice: null,
    operatingCost: 16500,
    tier: 5,
    image: "./aircraft/collectibles/rare/777-xr8-ed.png",
  },
  "a400": {
    model: "A400",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "rare",
    tagline: "Airbus goes big.",
    capacity: 360,
    range: 7800,
    cruiseSpeed: 505,
    fuelBurn: 9500,
    purchasePrice: 350000000,
    leasePrice: null,
    operatingCost: 14500,
    tier: 5,
    image: "./aircraft/collectibles/rare/a400.png",
  },
  "a410": {
    model: "A410",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "rare",
    tagline: "The refined giant.",
    capacity: 390,
    range: 8200,
    cruiseSpeed: 510,
    fuelBurn: 10000,
    purchasePrice: 370000000,
    leasePrice: null,
    operatingCost: 15200,
    tier: 5,
    image: "./aircraft/collectibles/rare/a410.png",
  },
  "ilyushin-illusion": {
    model: "Ilyushin Illusion",
    manufacturer: "Ilyushin",
    category: "collectible",
    rarity: "rare",
    tagline: "Russia's redemption.",
    capacity: 350,
    range: 7500,
    cruiseSpeed: 490,
    fuelBurn: 9200,
    purchasePrice: 280000000,
    leasePrice: null,
    operatingCost: 13000,
    tier: 5,
    image: "./aircraft/collectibles/rare/ilyushin-illusion.png",
  },
  "concord-harmonia": {
    model: "Concord Harmonia",
    manufacturer: "Aerospatiale-BAC",
    category: "collectible",
    rarity: "rare",
    tagline: "Supersonic democracy. Mach 2 for the masses.",
    capacity: 180,
    range: 5500,
    cruiseSpeed: 1350,
    fuelBurn: 18000,
    purchasePrice: 500000000,
    leasePrice: null,
    operatingCost: 35000,
    tier: 5,
    image: "./aircraft/collectibles/rare/concord-harmonia.png",
  },
  "vc-32a": {
    model: "VC-32A Air Force Two",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "The Vice President's ride.",
    capacity: 45,
    range: 5500,
    cruiseSpeed: 545,
    fuelBurn: 3500,
    purchasePrice: 250000000,
    leasePrice: null,
    operatingCost: 12000,
    tier: 5,
    image: "./aircraft/collectibles/rare/vc-32a.png",
  },
  "a340-8000": {
    model: "Airbus A340-8000",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "rare",
    tagline: "The Sultan's preference.",
    capacity: 60,
    range: 9000,
    cruiseSpeed: 510,
    fuelBurn: 7500,
    purchasePrice: 320000000,
    leasePrice: null,
    operatingCost: 14000,
    tier: 5,
    image: "./aircraft/collectibles/rare/a340-8000.png",
  },
  "eclipse-500": {
    model: "Eclipse 500",
    manufacturer: "Eclipse Aviation",
    category: "collectible",
    rarity: "rare",
    tagline: "The revolution that wasn't.",
    capacity: 4,
    range: 1125,
    cruiseSpeed: 425,
    fuelBurn: 400,
    purchasePrice: 2500000,
    leasePrice: null,
    operatingCost: 800,
    tier: 5,
    image: "./aircraft/collectibles/rare/eclipse-500.png",
  },
  "kc-135e": {
    model: "KC-135E Stratotanker",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "Gas station in the sky. 60 years and counting.",
    capacity: 0,
    range: 9200,
    cruiseSpeed: 480,
    fuelBurn: 6000,
    purchasePrice: 150000000,
    leasePrice: null,
    operatingCost: 10000,
    tier: 5,
    image: "./aircraft/collectibles/rare/kc-135e.png",
  },
  "kc-10a": {
    model: "KC-10A Extender",
    manufacturer: "McDonnell Douglas",
    category: "collectible",
    rarity: "rare",
    tagline: "The DC-10's military career.",
    capacity: 75,
    range: 11500,
    cruiseSpeed: 510,
    fuelBurn: 9500,
    purchasePrice: 180000000,
    leasePrice: null,
    operatingCost: 14000,
    tier: 5,
    image: "./aircraft/collectibles/rare/kc-10a.png",
  },
  "c-17a": {
    model: "C-17A Globemaster III",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "Anywhere, anything.",
    capacity: 134,
    range: 5200,
    cruiseSpeed: 475,
    fuelBurn: 10500,
    purchasePrice: 340000000,
    leasePrice: null,
    operatingCost: 18000,
    tier: 5,
    image: "./aircraft/collectibles/rare/c-17a.png",
  },
  "a400m-atlas": {
    model: "A400M Atlas",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "rare",
    tagline: "Europe's airlifter.",
    capacity: 116,
    range: 4800,
    cruiseSpeed: 450,
    fuelBurn: 4200,
    purchasePrice: 180000000,
    leasePrice: null,
    operatingCost: 9000,
    tier: 5,
    image: "./aircraft/collectibles/rare/a400m-atlas.png",
  },
  "kc-46a": {
    model: "KC-46A Pegasus",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "The replacement that took forever.",
    capacity: 58,
    range: 6385,
    cruiseSpeed: 510,
    fuelBurn: 5800,
    purchasePrice: 200000000,
    leasePrice: null,
    operatingCost: 11000,
    tier: 5,
    image: "./aircraft/collectibles/rare/kc-46a.png",
  },
  "p-8a": {
    model: "P-8A Poseidon",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "A 737 with torpedoes.",
    capacity: 0,
    range: 4500,
    cruiseSpeed: 510,
    fuelBurn: 3200,
    purchasePrice: 290000000,
    leasePrice: null,
    operatingCost: 9500,
    tier: 5,
    image: "./aircraft/collectibles/rare/p-8a.png",
  },
  "c-40a": {
    model: "C-40A Clipper",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "The Navy's business class.",
    capacity: 121,
    range: 5500,
    cruiseSpeed: 510,
    fuelBurn: 2800,
    purchasePrice: 85000000,
    leasePrice: null,
    operatingCost: 6500,
    tier: 5,
    image: "./aircraft/collectibles/rare/c-40a.png",
  },

  // --------------------------------------------------------------------------
  // RELIC TIER (10% roll chance) - 21 Aircraft
  // --------------------------------------------------------------------------

  "spirit-of-st-louis": {
    model: "Spirit of St. Louis",
    manufacturer: "Ryan Airlines",
    category: "collectible",
    rarity: "relic",
    tagline: "33 hours. One pilot. No forward visibility.",
    capacity: 1,
    range: 4000,
    cruiseSpeed: 110,
    fuelBurn: 50,
    purchasePrice: 50000000,
    leasePrice: null,
    operatingCost: 500,
    tier: 5,
    image: "./aircraft/collectibles/relic/spirit-of-st-louis.png",
  },
  "wright-flyer": {
    model: "Wright Flyer",
    manufacturer: "Wright Brothers",
    category: "collectible",
    rarity: "relic",
    tagline: "12 seconds that changed everything.",
    capacity: 1,
    range: 1,
    cruiseSpeed: 30,
    fuelBurn: 5,
    purchasePrice: 100000000,
    leasePrice: null,
    operatingCost: 100,
    tier: 5,
    flyable: false,
    image: "./aircraft/collectibles/relic/wright-flyer.png",
  },
  "benoist-xiv": {
    model: "Benoist XIV",
    manufacturer: "Benoist",
    category: "collectible",
    rarity: "relic",
    tagline: "First airline flight. Tampa Bay, 1914.",
    capacity: 1,
    range: 30,
    cruiseSpeed: 64,
    fuelBurn: 15,
    purchasePrice: 40000000,
    leasePrice: null,
    operatingCost: 200,
    tier: 5,
    image: "./aircraft/collectibles/relic/benoist-xiv.png",
  },
  "hughes-h4-hercules": {
    model: "Hughes H-4 Hercules",
    manufacturer: "Hughes Aircraft",
    category: "collectible",
    rarity: "relic",
    tagline: "The Spruce Goose. Flew once. Worth it.",
    capacity: 750,
    range: 3000,
    cruiseSpeed: 175,
    fuelBurn: 3000,
    purchasePrice: 200000000,
    leasePrice: null,
    operatingCost: 25000,
    tier: 5,
    image: "./aircraft/collectibles/relic/hughes-h4-hercules.png",
  },
  "douglas-dc3-dakota": {
    model: "Douglas DC-3 Dakota",
    manufacturer: "Douglas",
    category: "collectible",
    rarity: "relic",
    tagline: "The plane that won the war.",
    capacity: 32,
    range: 1500,
    cruiseSpeed: 180,
    fuelBurn: 350,
    purchasePrice: 15000000,
    leasePrice: null,
    operatingCost: 2000,
    tier: 5,
    image: "./aircraft/collectibles/relic/douglas-dc3-dakota.png",
  },
  "lockheed-electra-10e": {
    model: "Lockheed Electra 10E",
    manufacturer: "Lockheed",
    category: "collectible",
    rarity: "relic",
    tagline: "Amelia's last flight.",
    capacity: 1,
    range: 700,
    cruiseSpeed: 190,
    fuelBurn: 180,
    purchasePrice: 35000000,
    leasePrice: null,
    operatingCost: 1500,
    tier: 5,
    image: "./aircraft/collectibles/relic/lockheed-electra-10e.png",
  },
  "dh106-comet": {
    model: "DH.106 Comet",
    manufacturer: "de Havilland",
    category: "collectible",
    rarity: "relic",
    tagline: "First jet airliner. Beautiful mistake.",
    capacity: 44,
    range: 2400,
    cruiseSpeed: 460,
    fuelBurn: 4500,
    purchasePrice: 25000000,
    leasePrice: null,
    operatingCost: 8000,
    tier: 5,
    image: "./aircraft/collectibles/relic/dh106-comet.png",
  },
  "boeing-707-relic": {
    model: "Boeing 707",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "relic",
    tagline: "The jet age begins.",
    capacity: 189,
    range: 5750,
    cruiseSpeed: 540,
    fuelBurn: 6500,
    purchasePrice: 30000000,
    leasePrice: null,
    operatingCost: 12000,
    tier: 5,
    image: "./aircraft/collectibles/relic/boeing-707.png",
  },
  "douglas-dc8-ship-one": {
    model: "DC-8 Ship One",
    manufacturer: "Douglas",
    category: "collectible",
    rarity: "relic",
    tagline: "The prototype. First of type.",
    capacity: 176,
    range: 6000,
    cruiseSpeed: 530,
    fuelBurn: 6200,
    purchasePrice: 28000000,
    leasePrice: null,
    operatingCost: 11000,
    tier: 5,
    image: "./aircraft/collectibles/relic/douglas-dc8-ship-one.png",
  },
  "enola-gay": {
    model: "Enola Gay",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "relic",
    tagline: "August 6, 1945. All stats: 235.",
    capacity: 235,
    range: 235,
    cruiseSpeed: 235,
    fuelBurn: 235,
    purchasePrice: 235000000,
    leasePrice: null,
    operatingCost: 2350,
    tier: 5,
    image: "./aircraft/collectibles/relic/enola-gay.png",
  },
  "vc-25a": {
    model: "VC-25A Air Force One",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "relic",
    tagline: "The flying White House.",
    capacity: 76,
    range: 7800,
    cruiseSpeed: 600,
    fuelBurn: 10000,
    purchasePrice: 500000000,
    leasePrice: null,
    operatingCost: 25000,
    tier: 5,
    image: "./aircraft/collectibles/relic/vc-25a.png",
  },
  "vc-137c": {
    model: "VC-137C SAM 26000",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "relic",
    tagline: "Kennedy's last flight. LBJ sworn in aboard.",
    capacity: 40,
    range: 5750,
    cruiseSpeed: 540,
    fuelBurn: 6000,
    purchasePrice: 150000000,
    leasePrice: null,
    operatingCost: 15000,
    tier: 5,
    image: "./aircraft/collectibles/relic/vc-137c.png",
  },
  "vc-121e": {
    model: "VC-121E Columbine III",
    manufacturer: "Lockheed",
    category: "collectible",
    rarity: "relic",
    tagline: "Ike's Constellation.",
    capacity: 24,
    range: 4600,
    cruiseSpeed: 340,
    fuelBurn: 1800,
    purchasePrice: 80000000,
    leasePrice: null,
    operatingCost: 8000,
    tier: 5,
    image: "./aircraft/collectibles/relic/vc-121e.png",
  },
  "vc-54c": {
    model: "VC-54C Sacred Cow",
    manufacturer: "Douglas",
    category: "collectible",
    rarity: "relic",
    tagline: "FDR's freedom. First presidential aircraft.",
    capacity: 12,
    range: 3900,
    cruiseSpeed: 280,
    fuelBurn: 1200,
    purchasePrice: 60000000,
    leasePrice: null,
    operatingCost: 5000,
    tier: 5,
    image: "./aircraft/collectibles/relic/vc-54c.png",
  },
  "tu-144": {
    model: "Tu-144 Charger",
    manufacturer: "Tupolev",
    category: "collectible",
    rarity: "relic",
    tagline: "Soviet Concorde. 55 flights ever.",
    capacity: 140,
    range: 3500,
    cruiseSpeed: 1400,
    fuelBurn: 22000,
    purchasePrice: 180000000,
    leasePrice: null,
    operatingCost: 40000,
    tier: 5,
    image: "./aircraft/collectibles/relic/tu-144.png",
  },
  "concorde-relic": {
    model: "Concorde",
    manufacturer: "Aerospatiale-BAC",
    category: "collectible",
    rarity: "relic",
    tagline: "NYC to London in 3.5 hours. Nothing since.",
    capacity: 100,
    range: 4500,
    cruiseSpeed: 1520,
    fuelBurn: 20000,
    purchasePrice: 250000000,
    leasePrice: null,
    operatingCost: 38000,
    tier: 5,
    image: "./aircraft/collectibles/relic/concorde.png",
  },
  "an-225": {
    model: "An-225 Mriya",
    manufacturer: "Antonov",
    category: "collectible",
    rarity: "relic",
    tagline: "Largest ever built. Destroyed 2022. Never forgotten.",
    capacity: 0,
    range: 4000,
    cruiseSpeed: 475,
    fuelBurn: 15000,
    purchasePrice: 300000000,
    leasePrice: null,
    operatingCost: 30000,
    tier: 5,
    image: "./aircraft/collectibles/relic/an-225.png",
  },
  "super-guppy": {
    model: "Super Guppy",
    manufacturer: "Aero Spacelines",
    category: "collectible",
    rarity: "relic",
    tagline: "Nose swings open. Carried Saturn V.",
    capacity: 0,
    range: 1500,
    cruiseSpeed: 250,
    fuelBurn: 2500,
    purchasePrice: 45000000,
    leasePrice: null,
    operatingCost: 8000,
    tier: 5,
    image: "./aircraft/collectibles/relic/super-guppy.png",
  },
  "y-10": {
    model: "Shanghai Y-10",
    manufacturer: "Shanghai Aviation",
    category: "collectible",
    rarity: "relic",
    tagline: "China's first jet. Cancelled 1985.",
    capacity: 178,
    range: 5560,
    cruiseSpeed: 535,
    fuelBurn: 6800,
    purchasePrice: 35000000,
    leasePrice: null,
    operatingCost: 11000,
    tier: 5,
    image: "./aircraft/collectibles/relic/y-10.png",
  },
  "n250": {
    model: "IPTN N-250",
    manufacturer: "IPTN",
    category: "collectible",
    rarity: "relic",
    tagline: "Indonesia's dream. Killed by the crisis.",
    capacity: 64,
    range: 1500,
    cruiseSpeed: 360,
    fuelBurn: 1200,
    purchasePrice: 20000000,
    leasePrice: null,
    operatingCost: 4000,
    tier: 5,
    image: "./aircraft/collectibles/relic/n250.png",
  },
  "dc-3-heritage": {
    model: "DC-3 Heritage Edition",
    manufacturer: "Douglas",
    category: "collectible",
    rarity: "relic",
    tagline: "Simulation mode exclusive. The legend, preserved.",
    capacity: 32,
    range: 1500,
    cruiseSpeed: 180,
    fuelBurn: 350,
    purchasePrice: 25000000,
    leasePrice: null,
    operatingCost: 2500,
    tier: 5,
    simModeOnly: true,
    image: "./aircraft/collectibles/relic/dc-3-heritage.png",
  },

  // --------------------------------------------------------------------------
  // ANOMALOUS TIER (5% roll chance) - 25 Aircraft
  // WARNING: These intentionally violate normal gameplay expectations
  // --------------------------------------------------------------------------

  "agee-whells": {
    model: "The Agee Whells",
    manufacturer: "Unknown",
    category: "collectible",
    rarity: "anomalous",
    tagline: "All other flights reverse course.",
    capacity: 200,
    range: 6000,
    cruiseSpeed: 450,
    fuelBurn: 5000,
    purchasePrice: 666000000,
    leasePrice: null,
    operatingCost: 15000,
    tier: 5,
    specialEffect: "reverses_all_flights",
    image: "./aircraft/collectibles/anomalous/agee-whells.png",
  },
  "yesterday": {
    model: "Yesterday",
    manufacturer: "Temporal Industries",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Always arrives yesterday.",
    capacity: 180,
    range: 4000,
    cruiseSpeed: 480,
    fuelBurn: 4500,
    purchasePrice: 450000000,
    leasePrice: null,
    operatingCost: 12000,
    tier: 5,
    specialEffect: "arrives_yesterday",
    image: "./aircraft/collectibles/anomalous/yesterday.png",
  },
  "timeline-fork": {
    model: "Timeline Fork",
    manufacturer: "Quantum Dynamics",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Creates alternate timeline on landing.",
    capacity: 200,
    range: 6000,
    cruiseSpeed: 520,
    fuelBurn: 5200,
    purchasePrice: 500000000,
    leasePrice: null,
    operatingCost: 14000,
    tier: 5,
    specialEffect: "timeline_fork",
    image: "./aircraft/collectibles/anomalous/timeline-fork.png",
  },
  "the-perpetual": {
    model: "The Perpetual",
    manufacturer: "Unknown",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Never lands. Launched 1987. Still airborne.",
    capacity: 250,
    range: 99999,
    displayRange: "∞",
    cruiseSpeed: 450,
    fuelBurn: 0,
    purchasePrice: 777000000,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    specialEffect: "never_lands",
    image: "./aircraft/collectibles/anomalous/the-perpetual.png",
  },
  "vtonly": {
    model: "VTOnly",
    manufacturer: "Vertical Concepts",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Origin equals destination. Vertical only.",
    capacity: 50,
    range: 0,
    cruiseSpeed: 0,
    fuelBurn: 1000,
    purchasePrice: 100000000,
    leasePrice: null,
    operatingCost: 5000,
    tier: 5,
    flyable: false,
    image: "./aircraft/collectibles/anomalous/vtonly.png",
  
    specialEffect: "VIP transport only - cannot carry regular passengers",},
  "the-mobius": {
    model: "The Mobius",
    manufacturer: "Topology Inc",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Always returns to origin. Infinite loop.",
    capacity: 200,
    range: 0,
    cruiseSpeed: 400,
    fuelBurn: 4000,
    purchasePrice: 350000000,
    leasePrice: null,
    operatingCost: 10000,
    tier: 5,
    specialEffect: "returns_to_origin",
    image: "./aircraft/collectibles/anomalous/the-mobius.png",
  },
  "negative-one": {
    model: "Negative One",
    manufacturer: "Antimatter Corp",
    category: "collectible",
    rarity: "anomalous",
    tagline: "All stats negative. Generates fuel.",
    capacity: 1,
    displayCapacity: -1,
    range: 1000,
    displayRange: -1000,
    cruiseSpeed: 100,
    displaySpeed: -100,
    fuelBurn: -500,
    purchasePrice: 1,
    leasePrice: null,
    operatingCost: -5000,
    tier: 5,
    specialEffect: "negative_stats",
    image: "./aircraft/collectibles/anomalous/negative-one.png",
  },
  "the-fold": {
    model: "The Fold",
    manufacturer: "Spacetime Ltd",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Folds space. Instant. $47M fuel cost.",
    capacity: 400,
    range: 1,
    cruiseSpeed: 9999,
    displaySpeed: "∞",
    fuelBurn: 47000000,
    purchasePrice: 999000000,
    leasePrice: null,
    operatingCost: 47000000,
    tier: 5,
    specialEffect: "instant_travel",
    image: "./aircraft/collectibles/anomalous/the-fold.png",
  },
  "quantum-hopper": {
    model: "Quantum Hopper",
    manufacturer: "Schrodinger Aerospace",
    category: "collectible",
    rarity: "anomalous",
    tagline: "May arrive before departure.",
    capacity: 150,
    range: 9999,
    cruiseSpeed: 9999,
    fuelBurn: 3000,
    purchasePrice: 550000000,
    leasePrice: null,
    operatingCost: 8000,
    tier: 5,
    specialEffect: "superposition",
    image: "./aircraft/collectibles/anomalous/quantum-hopper.png",
  },
  "the-bermudan": {
    model: "The Bermudan",
    manufacturer: "Triangle Aviation",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Every flight diverts to Bermuda Triangle.",
    capacity: 180,
    range: 4500,
    cruiseSpeed: 420,
    fuelBurn: 4800,
    purchasePrice: 280000000,
    leasePrice: null,
    operatingCost: 11000,
    tier: 5,
    specialEffect: "diverts_bermuda",
    image: "./aircraft/collectibles/anomalous/the-bermudan.png",
  },
  "the-moonshiner": {
    model: "The Moonshiner",
    manufacturer: "Appalachian Air",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Red-eye only. Runs on moonshine.",
    capacity: 80,
    range: 2500,
    cruiseSpeed: 380,
    fuelBurn: 800,
    purchasePrice: 150000000,
    leasePrice: null,
    operatingCost: 3000,
    tier: 5,
    specialEffect: "red_eye_only",
    image: "./aircraft/collectibles/anomalous/the-moonshiner.png",
  },
  "ghost-freight": {
    model: "Ghost Freight",
    manufacturer: "Unknown",
    category: "collectible",
    rarity: "anomalous",
    tagline: "No crew. No fuel. No cargo. Still profitable.",
    capacity: 0,
    range: 15000,
    cruiseSpeed: 620,
    fuelBurn: 0,
    purchasePrice: 400000000,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    specialEffect: "ghost_operation",
    image: "./aircraft/collectibles/anomalous/ghost-freight.png",
  },
  "blackout": {
    model: "Blackout",
    manufacturer: "Redacted",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Disappears from radar and memory.",
    capacity: 300,
    range: 8000,
    cruiseSpeed: 540,
    fuelBurn: 8000,
    purchasePrice: 450000000,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    specialEffect: "invisible",
    image: "./aircraft/collectibles/anomalous/blackout.png",
  },
  "the-jinx": {
    model: "The Jinx",
    manufacturer: "Murphy's Law Aviation",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Every flight causes another to fail.",
    capacity: 200,
    range: 5000,
    cruiseSpeed: 500,
    fuelBurn: 5000,
    purchasePrice: 250000000,
    leasePrice: null,
    operatingCost: 12000,
    tier: 5,
    specialEffect: "causes_failure",
    image: "./aircraft/collectibles/anomalous/the-jinx.png",
  },
  "echo-flight": {
    model: "Echo Flight",
    manufacturer: "Recursion Inc",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Duplicates on each flight. Cannot unschedule.",
    capacity: 150,
    range: 4000,
    cruiseSpeed: 450,
    fuelBurn: 4000,
    purchasePrice: 300000000,
    leasePrice: null,
    operatingCost: 10000,
    tier: 5,
    specialEffect: "duplicates",
    image: "./aircraft/collectibles/anomalous/echo-flight.png",
  },
  "probability-storm": {
    model: "Probability Storm",
    manufacturer: "Heisenberg Aviation",
    category: "collectible",
    rarity: "anomalous",
    tagline: "All outcomes happen simultaneously.",
    capacity: 200,
    range: 5000,
    cruiseSpeed: 500,
    fuelBurn: 5000,
    purchasePrice: 380000000,
    leasePrice: null,
    operatingCost: 11000,
    tier: 5,
    specialEffect: "all_outcomes",
    image: "./aircraft/collectibles/anomalous/probability-storm.png",
  },
  "spruce-moose": {
    model: "Spruce Moose",
    manufacturer: "Burns Industries",
    category: "collectible",
    rarity: "anomalous",
    tagline: "I said hop in!",
    capacity: 0,
    range: 0,
    cruiseSpeed: 0,
    fuelBurn: 0,
    purchasePrice: 1000000,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    flyable: false,
    image: "./aircraft/collectibles/anomalous/spruce-moose.png",
  
    specialEffect: "Generates $0.01 revenue, instant flight completion",},
  "the-anchor": {
    model: "The Anchor",
    manufacturer: "Spite Aerospace",
    category: "collectible",
    rarity: "anomalous",
    tagline: "1 knot cruise. JFK to LAX: 97 days.",
    capacity: 300,
    range: 8000,
    cruiseSpeed: 1,
    fuelBurn: 15000,
    purchasePrice: 200000000,
    leasePrice: null,
    operatingCost: 50000,
    tier: 5,
    image: "./aircraft/collectibles/anomalous/the-anchor.png",
  
    specialEffect: "Cannot be sold or scrapped, permanent fleet addition",},
  "revenue-engine": {
    model: "Revenue Engine",
    manufacturer: "Wall Street Wings",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Can't fly. Generates $10M/day.",
    capacity: 0,
    range: 0,
    cruiseSpeed: 0,
    fuelBurn: 0,
    purchasePrice: 1000000000,
    leasePrice: null,
    operatingCost: -10000000,
    tier: 5,
    flyable: false,
    specialEffect: "money_printer",
    image: "./aircraft/collectibles/anomalous/revenue-engine.png",
  },
  "market-maker": {
    model: "Market Maker",
    manufacturer: "SEC Investigations",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Each flight sends fuel prices into chaos.",
    capacity: 1,
    range: 5000,
    cruiseSpeed: 500,
    fuelBurn: 100,
    purchasePrice: 500000000,
    leasePrice: null,
    operatingCost: 1000,
    tier: 5,
    specialEffect: "market_manipulation",
    image: "./aircraft/collectibles/anomalous/market-maker.png",
  },
  "schrodinger-jet": {
    model: "Schrodinger Jet",
    manufacturer: "Uncertainty Ltd",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Negative passengers. Still profitable.",
    capacity: 1,
    displayCapacity: -1,
    range: 5000,
    cruiseSpeed: 500,
    fuelBurn: 4000,
    purchasePrice: 320000000,
    leasePrice: null,
    operatingCost: 9000,
    tier: 5,
    specialEffect: "negative_passengers",
    image: "./aircraft/collectibles/anomalous/schrodinger-jet.png",
  },
  "null-pointer": {
    model: "Null Pointer",
    manufacturer: "Exception Handling Inc",
    category: "collectible",
    rarity: "anomalous",
    tagline: "All values return null.",
    capacity: 1,
    displayCapacity: "null",
    range: 1000,
    displayRange: "null",
    cruiseSpeed: 100,
    displaySpeed: "null",
    fuelBurn: 1000,
    purchasePrice: 404000000,
    leasePrice: null,
    operatingCost: 4040,
    tier: 5,
    specialEffect: "null_values",
    image: "./aircraft/collectibles/anomalous/null-pointer.png",
  },
  "infinite-loop": {
    model: "Infinite Loop",
    manufacturer: "Cupertino Aviation",
    category: "collectible",
    rarity: "anomalous",
    tagline: "All stats are 8. Flies figure-8s forever.",
    capacity: 88,
    range: 8888,
    cruiseSpeed: 888,
    fuelBurn: 888,
    purchasePrice: 88888888,
    leasePrice: null,
    operatingCost: 8888,
    tier: 5,
    specialEffect: "figure_eight",
    image: "./aircraft/collectibles/anomalous/infinite-loop.png",
  },
  "the-debt": {
    model: "The Debt",
    manufacturer: "Compound Interest Corp",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Perfect stats. Compound negative interest.",
    capacity: 500,
    range: 10000,
    cruiseSpeed: 620,
    fuelBurn: 3000,
    purchasePrice: 1,
    leasePrice: null,
    operatingCost: 5000,
    tier: 5,
    specialEffect: "compound_debt",
    image: "./aircraft/collectibles/anomalous/the-debt.png",
  },
  "passenger-zero": {
    model: "Passenger Zero",
    manufacturer: "CDC Surplus",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Always Patient Zero for something.",
    capacity: 1,
    range: 12000,
    cruiseSpeed: 565,
    fuelBurn: 7000,
    purchasePrice: 270000000,
    leasePrice: null,
    operatingCost: 15000,
    tier: 5,
    specialEffect: "patient_zero",
    image: "./aircraft/collectibles/anomalous/passenger-zero.png",
  },
  "the-code": {
    model: "The Code",
    manufacturer: "Unknown Origin",
    category: "collectible",
    rarity: "anomalous",
    tagline: "Made of yous. Thinks therefore it flies.",
    capacity: 128,
    range: 8192,
    cruiseSpeed: 512,
    fuelBurn: 4096,
    purchasePrice: 314159265,
    leasePrice: null,
    operatingCost: 2048,
    tier: 5,
    specialEffect: "the_code_minigame",
    specialAbilities: ["Launches 8-bit bug-squashing minigame on dispatch"],
    claimButtonText: "Launch this and squash some bugs!",
    image: "./aircraft/collectibles/anomalous/the-code.png",
  },

  // --------------------------------------------------------------------------
  // LEGENDARY TIER (5% roll chance) - 25 Aircraft
  // --------------------------------------------------------------------------

  "a550-mx-quantumliner": {
    model: "A550-MX Quantumliner",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "legendary",
    tagline: "AI-optimized. +15% satisfaction, -20% turnaround.",
    capacity: 380,
    range: 9200,
    cruiseSpeed: 545,
    fuelBurn: 9000,
    purchasePrice: 550000000,
    leasePrice: null,
    operatingCost: 16000,
    tier: 5,
    specialAbility: "+15% passenger satisfaction, -20% turnaround time",
    image: "./aircraft/collectibles/legendary/a550-mx-quantumliner.png",
  },
  "797-9000-cumulus": {
    model: "797-9000 CUMULUS",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "legendary",
    tagline: "FL510. Ignores weather. +25% revenue 8000+ nm.",
    capacity: 320,
    range: 12000,
    cruiseSpeed: 565,
    fuelBurn: 6500,
    purchasePrice: 480000000,
    leasePrice: null,
    operatingCost: 14000,
    tier: 5,
    specialAbility: "Ignores weather, +25% revenue on 8000+ nm routes",
    image: "./aircraft/collectibles/legendary/797-9000-cumulus.png",
  },
  "cx-fury-concorde": {
    model: "CX-Fury Concorde",
    manufacturer: "Fire Dragon Aerospace",
    category: "collectible",
    rarity: "legendary",
    tagline: "Mach 2. 3x ticket prices. 90% load factor.",
    capacity: 128,
    range: 5800,
    cruiseSpeed: 1520,
    fuelBurn: 22000,
    purchasePrice: 600000000,
    leasePrice: null,
    operatingCost: 45000,
    tier: 5,
    specialAbility: "3x ticket prices, guaranteed 90% load factor",
    image: "./aircraft/collectibles/legendary/cx-fury-concorde.png",
  },
  "serpentis-vii-777": {
    model: "Serpentis VII 777",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "legendary",
    tagline: "+20% crew satisfaction. -15% fuel in headwinds.",
    capacity: 350,
    range: 8800,
    cruiseSpeed: 535,
    fuelBurn: 7800,
    purchasePrice: 420000000,
    leasePrice: null,
    operatingCost: 15000,
    tier: 5,
    specialAbility: "+20% crew satisfaction, -15% fuel burn in headwinds",
    image: "./aircraft/collectibles/legendary/serpentis-vii-777.png",
  },
  "vc-25b": {
    model: "VC-25B Air Force One",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "legendary",
    tagline: "747-8 based. Most advanced command post ever.",
    capacity: 70,
    range: 8500,
    cruiseSpeed: 610,
    fuelBurn: 11000,
    purchasePrice: 750000000,
    leasePrice: null,
    operatingCost: 30000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/vc-25b.png",
  },
  "e-3a": {
    model: "E-3A AWACS Sentry",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "legendary",
    tagline: "30-foot rotodome. Sees 250 miles.",
    capacity: 30,
    range: 5000,
    cruiseSpeed: 485,
    fuelBurn: 7000,
    purchasePrice: 350000000,
    leasePrice: null,
    operatingCost: 18000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/e-3a.png",
  },
  "e-4b": {
    model: "E-4B Nightwatch",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "legendary",
    tagline: "Doomsday plane. Nuclear EMP hardened.",
    capacity: 100,
    range: 7800,
    cruiseSpeed: 510,
    fuelBurn: 12000,
    purchasePrice: 500000000,
    leasePrice: null,
    operatingCost: 25000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/e-4b.png",
  },
  "c-5m": {
    model: "C-5M Super Galaxy",
    manufacturer: "Lockheed Martin",
    category: "collectible",
    rarity: "legendary",
    tagline: "Carries 2 Abrams tanks. Or 500 passengers.",
    capacity: 500,
    range: 5524,
    cruiseSpeed: 475,
    fuelBurn: 14000,
    purchasePrice: 380000000,
    leasePrice: null,
    operatingCost: 22000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/c-5m.png",
  },
  "beluga": {
    model: "Beluga",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "legendary",
    tagline: "The first whale. Looks ridiculous. Works perfectly.",
    capacity: 669,
    range: 2779,
    cruiseSpeed: 440,
    fuelBurn: 8500,
    purchasePrice: 200000000,
    leasePrice: null,
    operatingCost: 15000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/a300-600st.png",
  },
  "belugaxl": {
    model: "BelugaXL",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "legendary",
    tagline: "The bigger whale. Whale eyes on cockpit.",
    capacity: 713,
    range: 2500,
    cruiseSpeed: 455,
    fuelBurn: 9000,
    purchasePrice: 250000000,
    leasePrice: null,
    operatingCost: 16000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/a330-743l.png",
  },
  "dreamlifter": {
    model: "747-400LCF Dreamlifter",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "legendary",
    tagline: "Boeing's whale. Once landed at wrong airport.",
    capacity: 676,
    range: 4445,
    cruiseSpeed: 490,
    fuelBurn: 11000,
    purchasePrice: 230000000,
    leasePrice: null,
    operatingCost: 18000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/dreamlifter.png",
  },
  "sonic-cruiser": {
    model: "Boeing Sonic Cruiser",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "legendary",
    tagline: "Mach 0.98. The one that got away.",
    capacity: 250,
    range: 9000,
    cruiseSpeed: 625,
    fuelBurn: 7500,
    purchasePrice: 400000000,
    leasePrice: null,
    operatingCost: 16000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/sonic-cruiser.png",
  },
  "747x": {
    model: "Boeing 747X",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "legendary",
    tagline: "The stretched queen. 500 passengers.",
    capacity: 500,
    range: 8700,
    cruiseSpeed: 510,
    fuelBurn: 12500,
    purchasePrice: 380000000,
    leasePrice: null,
    operatingCost: 19000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/747x.png",
  },
  "a380neo": {
    model: "A380neo",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "legendary",
    tagline: "Emirates got their wish.",
    capacity: 615,
    range: 9200,
    cruiseSpeed: 510,
    fuelBurn: 10000,
    purchasePrice: 450000000,
    leasePrice: null,
    operatingCost: 17000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/a380neo.png",
  },
  "boom-overture": {
    model: "Boom Overture",
    manufacturer: "Boom Supersonic",
    category: "collectible",
    rarity: "legendary",
    tagline: "Mach 1.7. Supersonic returns.",
    capacity: 80,
    range: 4888,
    cruiseSpeed: 1290,
    fuelBurn: 12000,
    purchasePrice: 350000000,
    leasePrice: null,
    operatingCost: 28000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/boom-overture.png",
  },
  "a380-800f": {
    model: "A380-800F",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "legendary",
    tagline: "The freighter nobody wanted. 150 tons cargo.",
    capacity: 0,
    range: 5600,
    cruiseSpeed: 505,
    fuelBurn: 11000,
    purchasePrice: 400000000,
    leasePrice: null,
    operatingCost: 18000,
    tier: 5,
    cargoCapacity: 150000,
    image: "./aircraft/collectibles/legendary/a380-800f.png",
  },
  "boeing-2707": {
    model: "Boeing 2707 SST",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "legendary",
    tagline: "Mach 2.7. America's Concorde. Congress killed it.",
    capacity: 300,
    range: 4000,
    cruiseSpeed: 1850,
    fuelBurn: 35000,
    purchasePrice: 550000000,
    leasePrice: null,
    operatingCost: 55000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/boeing-2707.png",
  },
  "mrj90": {
    model: "Mitsubishi SpaceJet M90",
    manufacturer: "Mitsubishi",
    category: "collectible",
    rarity: "legendary",
    tagline: "$10B spent. Zero delivered. Finally flies.",
    capacity: 88,
    range: 2040,
    cruiseSpeed: 510,
    fuelBurn: 2200,
    purchasePrice: 55000000,
    leasePrice: null,
    operatingCost: 5500,
    tier: 5,
    image: "./aircraft/mrj90.png",
  },
  "md-12": {
    model: "MD-12",
    manufacturer: "McDonnell Douglas",
    category: "collectible",
    rarity: "legendary",
    tagline: "Double-deck trijet. Would've beaten A380.",
    capacity: 511,
    range: 7400,
    cruiseSpeed: 510,
    fuelBurn: 13000,
    purchasePrice: 420000000,
    leasePrice: null,
    operatingCost: 20000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/md-12.png",
  },
  "l-2000": {
    model: "Lockheed L-2000",
    manufacturer: "Lockheed",
    category: "collectible",
    rarity: "legendary",
    tagline: "Lost to Boeing 2707. Then both died.",
    capacity: 270,
    range: 4000,
    cruiseSpeed: 1850,
    fuelBurn: 32000,
    purchasePrice: 500000000,
    leasePrice: null,
    operatingCost: 50000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/l-2000.png",
  },
  "a2000": {
    model: "Airbus A2000",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "legendary",
    tagline: "800-seat study. A380 was the compromise.",
    capacity: 656,
    range: 8500,
    cruiseSpeed: 505,
    fuelBurn: 14000,
    purchasePrice: 500000000,
    leasePrice: null,
    operatingCost: 22000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/a2000.png",
  },
  "nma": {
    model: "Boeing NMA 797",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "legendary",
    tagline: "The middle market. Finally arrives.",
    capacity: 270,
    range: 5000,
    cruiseSpeed: 550,
    fuelBurn: 5500,
    purchasePrice: 160000000,
    leasePrice: null,
    operatingCost: 9000,
    tier: 5,
    image: "./aircraft/nma.png",
  },
  "stratolaunch": {
    model: "Stratolaunch Roc",
    manufacturer: "Stratolaunch",
    category: "collectible",
    rarity: "legendary",
    tagline: "385-foot wingspan. Launches rockets.",
    capacity: 0,
    range: 2000,
    cruiseSpeed: 350,
    fuelBurn: 8000,
    purchasePrice: 400000000,
    leasePrice: null,
    operatingCost: 20000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/stratolaunch.png",
  },
  "vc-25c": {
    model: "VC-25C Future AF1",
    manufacturer: "Classified",
    category: "collectible",
    rarity: "legendary",
    tagline: "Classified. Stealth? Hypersonic? [REDACTED]",
    capacity: 80,
    range: 10000,
    cruiseSpeed: 650,
    fuelBurn: 15000,
    purchasePrice: 1000000000,
    leasePrice: null,
    operatingCost: 40000,
    tier: 5,
    image: "./aircraft/collectibles/legendary/vc-25-concept.png",
  },
  "civil-c17": {
    model: "Boeing C-17 Civilian",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "legendary",
    tagline: "FedEx begged. Boeing finally caved.",
    capacity: 0,
    range: 5200,
    cruiseSpeed: 490,
    fuelBurn: 10000,
    purchasePrice: 300000000,
    leasePrice: null,
    operatingCost: 16000,
    tier: 5,
    cargoCapacity: 170000,
    image: "./aircraft/civil-c17.png",
  },

  // --------------------------------------------------------------------------
  // MYTHIC TIER (0.1% roll chance) - 1 Aircraft
  // ONE per server per month
  // --------------------------------------------------------------------------

  "ghost-apotheosis": {
    model: "Ghost Apotheosis",
    manufacturer: "Classified",
    category: "collectible",
    rarity: "mythic",
    tagline: "It doesn't exist. None of this is happening.",
    capacity: 620,
    range: 10000,
    cruiseSpeed: 999,
    fuelBurn: 5000,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    specialAbility: "Radar invisible, +20% cruise speed, premium fares, $1B cash bonus",
    onePerMonth: true,
    image: "./aircraft/collectibles/mythic/ghost-apotheosis.png",
  },

  // ============================================================================
  // BATCH 2: CLASSIC JETS - Extinct Legends
  // ============================================================================

  "707-120": {
    model: "707-120",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 140,
    range: 4200,
    cruiseSpeed: 540,
    fuelBurn: 6800,
    purchasePrice: 8500000,
    leasePrice: 125000,
    operatingCost: 12500,
    tier: 2,
    retired: true,
    description: "The jet age started here. Pan Am, 1958. Changed everything.",
  
    oew: 82000,
    mtow: 147600,
    mlw: 129888,
    minRunway: 7000,
    image: "./aircraft/707-120.png",},
  "707-320B": {
    model: "707-320B",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 189,
    range: 5750,
    cruiseSpeed: 525,
    fuelBurn: 6500,
    purchasePrice: 12000000,
    leasePrice: 145000,
    operatingCost: 13200,
    tier: 2,
    retired: true,
    description: "The definitive 707. Turbofan engines, global range.",
  
    oew: 96700,
    mtow: 174060,
    mlw: 153173,
    minRunway: 7000,
    image: "./aircraft/707-320b.png",},
  "720": {
    model: "720",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 130,
    range: 3800,
    cruiseSpeed: 550,
    fuelBurn: 5900,
    purchasePrice: 7200000,
    leasePrice: 110000,
    operatingCost: 11000,
    tier: 2,
    retired: true,
    description: "The forgotten sibling. Lighter, faster, shorter range. Only 154 built.",
  
    oew: 79000,
    mtow: 142200,
    mlw: 125136,
    minRunway: 7000,
    image: "./aircraft/720.png",},
  "727-100": {
    model: "727-100",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 131,
    range: 2700,
    cruiseSpeed: 530,
    fuelBurn: 5400,
    purchasePrice: 9500000,
    leasePrice: 130000,
    operatingCost: 9800,
    tier: 2,
    retired: true,
    description: "The trijet that conquered America. Could operate from short runways.",
  
    oew: 79300,
    mtow: 142740,
    mlw: 125611,
    minRunway: 7000,
    image: "./aircraft/727-100.png",},
  "727-200": {
    model: "727-200",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 189,
    range: 2950,
    cruiseSpeed: 530,
    fuelBurn: 5800,
    purchasePrice: 11500000,
    leasePrice: 155000,
    operatingCost: 10500,
    tier: 2,
    retired: true,
    description: "Stretched 727. Workhorse of the 70s and 80s.",
  
    oew: 96700,
    mtow: 174060,
    mlw: 153173,
    minRunway: 7000,
    image: "./aircraft/727-200.png",},
  "Comet-4C": {
    model: "Comet 4C",
    manufacturer: "de Havilland",
    category: "narrowbody",
    capacity: 101,
    range: 3350,
    cruiseSpeed: 460,
    fuelBurn: 4200,
    purchasePrice: 6000000,
    leasePrice: 95000,
    operatingCost: 9500,
    tier: 2,
    retired: true,
    description: "The one that finally worked. First transatlantic jet service.",
  
    oew: 70300,
    mtow: 126540,
    mlw: 111355,
    minRunway: 7000,
    image: "./aircraft/comet-4c.png",},
  "Caravelle-III": {
    model: "Caravelle III",
    manufacturer: "Sud Aviation",
    category: "narrowbody",
    capacity: 80,
    range: 1650,
    cruiseSpeed: 490,
    fuelBurn: 3100,
    purchasePrice: 5500000,
    leasePrice: 85000,
    operatingCost: 7200,
    tier: 2,
    retired: true,
    description: "French elegance. Rear-mounted engines were revolutionary.",
  
    oew: 48000,
    mtow: 81600,
    mlw: 71808,
    minRunway: 7000,
    image: "./aircraft/caravelle-iii.png",},
  "Convair-880": {
    model: "Convair 880",
    manufacturer: "Convair",
    category: "narrowbody",
    capacity: 110,
    range: 3200,
    cruiseSpeed: 556,
    fuelBurn: 6200,
    purchasePrice: 7800000,
    leasePrice: 105000,
    operatingCost: 12800,
    tier: 2,
    retired: true,
    description: "The fastest subsonic airliner. Howard Hughes demanded it.",
  
    oew: 73000,
    mtow: 131400,
    mlw: 115632,
    minRunway: 7000,
    image: "./aircraft/convair-880.png",},
  "Convair-990": {
    model: "Convair 990",
    manufacturer: "Convair",
    category: "narrowbody",
    capacity: 121,
    range: 3800,
    cruiseSpeed: 558,
    fuelBurn: 6500,
    purchasePrice: 8200000,
    leasePrice: 112000,
    operatingCost: 13200,
    tier: 2,
    retired: true,
    description: "Even faster than the 880. Those distinctive speed pods. Only 37 built.",
  
    oew: 76300,
    mtow: 137340,
    mlw: 120859,
    minRunway: 7000,
    image: "./aircraft/convair-990.png",},
  "VC10": {
    model: "VC10",
    manufacturer: "Vickers",
    category: "narrowbody",
    capacity: 151,
    range: 5200,
    cruiseSpeed: 505,
    fuelBurn: 5800,
    purchasePrice: 9500000,
    leasePrice: 135000,
    operatingCost: 11500,
    tier: 2,
    retired: true,
    description: "BOAC's hot-and-high hero. Four rear engines.",
  
    oew: 85300,
    mtow: 153540,
    mlw: 135115,
    minRunway: 7000,
    image: "./aircraft/vc10.png",},
  "Trident-2E": {
    model: "Trident 2E",
    manufacturer: "Hawker Siddeley",
    category: "narrowbody",
    capacity: 149,
    range: 2400,
    cruiseSpeed: 505,
    fuelBurn: 4800,
    purchasePrice: 7500000,
    leasePrice: 108000,
    operatingCost: 9800,
    tier: 2,
    retired: true,
    description: "Britain's answer to the 727. First autoland in regular service.",
  
    oew: 84700,
    mtow: 152460,
    mlw: 134165,
    minRunway: 7000,
    image: "./aircraft/trident-2e.png",},
  "BAC-111-500": {
    model: "BAC One-Eleven 500",
    manufacturer: "BAC",
    category: "regional",
    capacity: 119,
    range: 1705,
    cruiseSpeed: 461,
    fuelBurn: 2900,
    purchasePrice: 5200000,
    leasePrice: 78000,
    operatingCost: 6800,
    tier: 1,
    retired: true,
    description: "Stretched British short-hauler. European Airlines' favorite.",
  
    oew: 61650,
    mtow: 104805,
    mlw: 92228,
    minRunway: 5500,
    image: "./aircraft/bac-111-500.png",},

  // ============================================================================
  // BATCH 3: TRIJET WIDEBODIES
  // ============================================================================

  "DC-10-10": {
    model: "DC-10-10",
    manufacturer: "McDonnell Douglas",
    category: "widebody",
    capacity: 270,
    range: 3800,
    cruiseSpeed: 530,
    fuelBurn: 8200,
    purchasePrice: 45000000,
    leasePrice: 420000,
    operatingCost: 18500,
    tier: 3,
    retired: true,
    description: "Domestic US trijet. American and United launch customers.",
  
    oew: 208000,
    mtow: 416000,
    mlw: 366080,
    minRunway: 9000,
    image: "./aircraft/dc-10-10.png",},
  "DC-10-15": {
    model: "DC-10-15",
    manufacturer: "McDonnell Douglas",
    category: "widebody",
    capacity: 270,
    range: 4000,
    cruiseSpeed: 530,
    fuelBurn: 8400,
    purchasePrice: 48000000,
    leasePrice: 440000,
    operatingCost: 19000,
    tier: 3,
    retired: true,
    description: "Hot and high variant. More powerful engines for Mexico City.",
  
    oew: 208000,
    mtow: 416000,
    mlw: 366080,
    minRunway: 9000,
    image: "./aircraft/dc-10-15.png",},
  "DC-10-30": {
    model: "DC-10-30",
    manufacturer: "McDonnell Douglas",
    category: "widebody",
    capacity: 270,
    range: 6200,
    cruiseSpeed: 530,
    fuelBurn: 8800,
    purchasePrice: 52000000,
    leasePrice: 480000,
    operatingCost: 19800,
    tier: 3,
    retired: true,
    description: "Intercontinental range. Swissair, KLM, Lufthansa's long-haul star.",
  
    oew: 208000,
    mtow: 416000,
    mlw: 366080,
    minRunway: 9000,
    image: "./aircraft/dc-10-30.png",},
  "DC-10-40": {
    model: "DC-10-40",
    manufacturer: "McDonnell Douglas",
    category: "widebody",
    capacity: 270,
    range: 5750,
    cruiseSpeed: 530,
    fuelBurn: 8600,
    purchasePrice: 50000000,
    leasePrice: 460000,
    operatingCost: 19200,
    tier: 3,
    retired: true,
    description: "Pratt & Whitney powered. Northwest and JAL only. The rarest DC-10.",
  
    oew: 208000,
    mtow: 416000,
    mlw: 366080,
    minRunway: 9000,
    image: "./aircraft/dc-10-40.png",},
  "MD-11": {
    model: "MD-11",
    manufacturer: "McDonnell Douglas",
    category: "widebody",
    capacity: 293,
    range: 7130,
    cruiseSpeed: 550,
    fuelBurn: 7800,
    purchasePrice: 78000000,
    leasePrice: 650000,
    operatingCost: 21000,
    tier: 4,
    retired: true,
    description: "The DC-10 evolved. Winglets, glass cockpit. Freighter life now.",
  
    oew: 217200,
    mtow: 434400,
    mlw: 382272,
    minRunway: 9000,
    image: "./aircraft/md-11.png",},
  "MD-11ER": {
    model: "MD-11ER",
    manufacturer: "McDonnell Douglas",
    category: "widebody",
    capacity: 285,
    range: 7970,
    cruiseSpeed: 550,
    fuelBurn: 8100,
    purchasePrice: 82000000,
    leasePrice: 680000,
    operatingCost: 21800,
    tier: 4,
    retired: true,
    description: "Extended range. Finally delivered on the promises. Only 5 built.",
  
    oew: 214000,
    mtow: 428000,
    mlw: 376640,
    minRunway: 9000,
    image: "./aircraft/md-11er.png",},
  "MD-11CF": {
    model: "MD-11CF",
    manufacturer: "McDonnell Douglas",
    category: "widebody",
    type: "combi",
    capacity: 180,
    cargoCapacity: 80000,
    range: 6850,
    cruiseSpeed: 545,
    fuelBurn: 7900,
    purchasePrice: 75000000,
    leasePrice: 620000,
    operatingCost: 20500,
    tier: 4,
    retired: true,
    description: "Convertible freighter. Passengers by day, cargo by night.",
  
    oew: 94000,
    mtow: 169200,
    mlw: 148896,
    minRunway: 9000,
    image: "./aircraft/md-11cf.png",},
  "L-1011-1": {
    model: "L-1011-1",
    manufacturer: "Lockheed",
    category: "widebody",
    capacity: 256,
    range: 2880,
    cruiseSpeed: 520,
    fuelBurn: 7200,
    purchasePrice: 48000000,
    leasePrice: 440000,
    operatingCost: 17200,
    tier: 3,
    retired: true,
    description: "The pilot's favorite. Direct lift control, autoland.",
  
    oew: 202400,
    mtow: 404800,
    mlw: 356224,
    minRunway: 9000,
    image: "./aircraft/l-1011-1.png",},
  "L-1011-100": {
    model: "L-1011-100",
    manufacturer: "Lockheed",
    category: "widebody",
    capacity: 256,
    range: 3840,
    cruiseSpeed: 520,
    fuelBurn: 7400,
    purchasePrice: 52000000,
    leasePrice: 470000,
    operatingCost: 17800,
    tier: 3,
    retired: true,
    description: "Extended range model. Center fuel tank. TWA loved them.",
  
    oew: 202400,
    mtow: 404800,
    mlw: 356224,
    minRunway: 9000,
    image: "./aircraft/l-1011-100.png",},
  "L-1011-200": {
    model: "L-1011-200",
    manufacturer: "Lockheed",
    category: "widebody",
    capacity: 256,
    range: 4150,
    cruiseSpeed: 520,
    fuelBurn: 7600,
    purchasePrice: 55000000,
    leasePrice: 490000,
    operatingCost: 18200,
    tier: 3,
    retired: true,
    description: "More powerful engines for hot and high. Saudia, Gulf Air.",
  
    oew: 202400,
    mtow: 404800,
    mlw: 356224,
    minRunway: 9000,
    image: "./aircraft/l-1011-200.png",},
  "L-1011-500": {
    model: "L-1011-500",
    manufacturer: "Lockheed",
    category: "widebody",
    capacity: 234,
    range: 5280,
    cruiseSpeed: 530,
    fuelBurn: 7000,
    purchasePrice: 58000000,
    leasePrice: 520000,
    operatingCost: 17000,
    tier: 3,
    retired: true,
    description: "Shortened fuselage, longer range. British Airways' favorite.",
  
    oew: 193600,
    mtow: 387200,
    mlw: 340736,
    minRunway: 9000,
    image: "./aircraft/l-1011-500.png",},

  // ============================================================================
  // BATCH 4: SOVIET/RUSSIAN FLEET (store aircraft only)
  // ============================================================================

  "Tu-104A": {
    model: "Tu-104A",
    manufacturer: "Tupolev",
    category: "narrowbody",
    capacity: 70,
    range: 2120,
    cruiseSpeed: 500,
    fuelBurn: 5200,
    purchasePrice: 4500000,
    leasePrice: 65000,
    operatingCost: 9800,
    tier: 2,
    retired: true,
    description: "First Soviet jet airliner. Based on Tu-16 bomber.",
  
    oew: 44500,
    mtow: 75650,
    mlw: 66572,
    minRunway: 7000,
    image: "./aircraft/tu-104a.png",},
  "Tu-114": {
    model: "Tu-114",
    manufacturer: "Tupolev",
    category: "widebody",
    capacity: 224,
    range: 5280,
    cruiseSpeed: 478,
    fuelBurn: 6800,
    purchasePrice: 12000000,
    leasePrice: 145000,
    operatingCost: 14500,
    tier: 3,
    retired: true,
    description: "Largest, fastest prop airliner ever. Moscow-Havana nonstop.",
  
    oew: 189600,
    mtow: 379200,
    mlw: 333696,
    minRunway: 9000,
    image: "./aircraft/tu-114.png",},
  "Tu-124": {
    model: "Tu-124",
    manufacturer: "Tupolev",
    category: "regional",
    capacity: 56,
    range: 1240,
    cruiseSpeed: 480,
    fuelBurn: 3200,
    purchasePrice: 3200000,
    leasePrice: 48000,
    operatingCost: 6500,
    tier: 1,
    retired: true,
    description: "Scaled down Tu-104. First turbofan airliner in service.",
  
    oew: 39600,
    mtow: 67320,
    mlw: 59242,
    minRunway: 5500,
    image: "./aircraft/tu-124.png",},
  "Tu-154B-2": {
    model: "Tu-154B-2",
    manufacturer: "Tupolev",
    category: "narrowbody",
    capacity: 180,
    range: 2400,
    cruiseSpeed: 560,
    fuelBurn: 6500,
    purchasePrice: 9500000,
    leasePrice: 125000,
    operatingCost: 11500,
    tier: 2,
    retired: true,
    description: "Soviet 727 equivalent. Three engines, austere field capable.",
  
    oew: 94000,
    mtow: 169200,
    mlw: 148896,
    minRunway: 7000,
    image: "./aircraft/tu-154b-2.png",},
  "Tu-154M": {
    model: "Tu-154M",
    manufacturer: "Tupolev",
    category: "narrowbody",
    capacity: 180,
    range: 3280,
    cruiseSpeed: 560,
    fuelBurn: 5500,
    purchasePrice: 12000000,
    leasePrice: 145000,
    operatingCost: 10800,
    tier: 2,
    retired: true,
    description: "Modernized. New engines, 30% better fuel burn. Still flying.",
  
    oew: 94000,
    mtow: 169200,
    mlw: 148896,
    minRunway: 7000,
    image: "./aircraft/tu-154m.png",},
  "Tu-204-100": {
    model: "Tu-204-100",
    manufacturer: "Tupolev",
    category: "narrowbody",
    capacity: 210,
    range: 4200,
    cruiseSpeed: 510,
    fuelBurn: 3200,
    purchasePrice: 35000000,
    leasePrice: 280000,
    operatingCost: 9200,
    tier: 3,
    description: "Russia's 757. Actually decent aircraft.",
  
    oew: 103000,
    mtow: 185400,
    mlw: 163152,
    minRunway: 7000,
    image: "./aircraft/tu-204-100.png",},
  "Tu-204-300": {
    model: "Tu-204-300",
    manufacturer: "Tupolev",
    category: "narrowbody",
    capacity: 166,
    range: 5200,
    cruiseSpeed: 510,
    fuelBurn: 2900,
    purchasePrice: 32000000,
    leasePrice: 260000,
    operatingCost: 8600,
    tier: 3,
    description: "Shortened fuselage, extended range.",
  
    oew: 89800,
    mtow: 161640,
    mlw: 142243,
    minRunway: 7000,
    image: "./aircraft/tu-204-300.png",},
  "Tu-214": {
    model: "Tu-214",
    manufacturer: "Tupolev",
    category: "narrowbody",
    capacity: 210,
    range: 4800,
    cruiseSpeed: 510,
    fuelBurn: 3300,
    purchasePrice: 38000000,
    leasePrice: 295000,
    operatingCost: 9500,
    tier: 3,
    description: "Tu-204 with Russian engines. Sanction-proof.",
  
    oew: 103000,
    mtow: 185400,
    mlw: 163152,
    minRunway: 7000,
    image: "./aircraft/tu-214.png",},
  "Il-18D": {
    model: "Il-18D",
    manufacturer: "Ilyushin",
    category: "narrowbody",
    capacity: 122,
    range: 4040,
    cruiseSpeed: 388,
    fuelBurn: 2400,
    purchasePrice: 4200000,
    leasePrice: 55000,
    operatingCost: 6800,
    tier: 2,
    retired: true,
    description: "Soviet Electra. Four turboprops. Incredibly reliable.",
  
    oew: 76600,
    mtow: 137880,
    mlw: 121334,
    minRunway: 7000,
    image: "./aircraft/il-18d.png",},
  "Il-86": {
    model: "Il-86",
    manufacturer: "Ilyushin",
    category: "widebody",
    capacity: 350,
    range: 2300,
    cruiseSpeed: 540,
    fuelBurn: 12500,
    purchasePrice: 35000000,
    leasePrice: 320000,
    operatingCost: 22000,
    tier: 3,
    retired: true,
    description: "First Soviet widebody. Passengers walked up stairs, stowed bags below.",
  
    oew: 240000,
    mtow: 480000,
    mlw: 422400,
    minRunway: 9000,
    image: "./aircraft/il-86.png",},
  "Il-96-300": {
    model: "Il-96-300",
    manufacturer: "Ilyushin",
    category: "widebody",
    capacity: 300,
    range: 6500,
    cruiseSpeed: 540,
    fuelBurn: 7800,
    purchasePrice: 65000000,
    leasePrice: 550000,
    operatingCost: 19500,
    tier: 4,
    description: "Four-engine widebody. Putin's presidential transport.",
  
    oew: 220000,
    mtow: 440000,
    mlw: 387200,
    minRunway: 9000,
    image: "./aircraft/il-96-300.png",},
  "Il-96-400M": {
    model: "Il-96-400M",
    manufacturer: "Ilyushin",
    category: "widebody",
    capacity: 370,
    range: 5800,
    cruiseSpeed: 540,
    fuelBurn: 8200,
    purchasePrice: 72000000,
    leasePrice: 590000,
    operatingCost: 20500,
    tier: 4,
    description: "Stretched, modernized. Russia's sanction-proof widebody.",
  
    oew: 248000,
    mtow: 496000,
    mlw: 436480,
    minRunway: 9000,
    image: "./aircraft/il-96-400m.png",},
  "An-24RV": {
    model: "An-24RV",
    manufacturer: "Antonov",
    category: "regional",
    capacity: 50,
    range: 1350,
    cruiseSpeed: 280,
    fuelBurn: 1100,
    purchasePrice: 2800000,
    leasePrice: 38000,
    operatingCost: 4500,
    tier: 1,
    retired: true,
    description: "Soviet Fokker F27. Auxiliary turbojet. Siberian bush plane.",
  
    oew: 37500,
    mtow: 63750,
    mlw: 56100,
    minRunway: 5500,
    image: "./aircraft/an-24rv.png",},
  "SSJ-100": {
    model: "Superjet 100",
    manufacturer: "Sukhoi",
    category: "regional",
    capacity: 98,
    range: 2470,
    cruiseSpeed: 510,
    fuelBurn: 2100,
    purchasePrice: 35000000,
    leasePrice: 285000,
    operatingCost: 6800,
    tier: 2,
    description: "Russia's regional jet. French engines, Western avionics.",
  
    oew: 54300,
    mtow: 92310,
    mlw: 81233,
    minRunway: 5500,
    image: "./aircraft/ssj-100.png",},
  "MC-21-300": {
    model: "MC-21-300",
    manufacturer: "Irkut",
    category: "narrowbody",
    capacity: 211,
    range: 3500,
    cruiseSpeed: 515,
    fuelBurn: 2800,
    purchasePrice: 48000000,
    leasePrice: 380000,
    operatingCost: 8500,
    tier: 3,
    description: "Russia's A320 competitor. Carbon composite wing.",
  
    oew: 103300,
    mtow: 185940,
    mlw: 163627,
    minRunway: 7000,
    image: "./aircraft/mc-21-300.png",},

  // ============================================================================
  // BATCH 5: REGIONAL TURBOPROPS & JETS
  // ============================================================================

  "Shorts-330": {
    model: "Shorts 330",
    manufacturer: "Short Brothers",
    category: "regional",
    capacity: 30,
    range: 560,
    cruiseSpeed: 190,
    fuelBurn: 680,
    purchasePrice: 1800000,
    leasePrice: 24000,
    operatingCost: 2800,
    tier: 1,
    retired: true,
    description: "The flying shoebox. Square fuselage, fixed gear.",
  
    oew: 30500,
    mtow: 51850,
    mlw: 45628,
    minRunway: 4000,
    image: "./aircraft/shorts-330.png",},
  "Shorts-360": {
    model: "Shorts 360",
    manufacturer: "Short Brothers",
    category: "regional",
    capacity: 36,
    range: 650,
    cruiseSpeed: 215,
    fuelBurn: 720,
    purchasePrice: 2200000,
    leasePrice: 28000,
    operatingCost: 3100,
    tier: 1,
    retired: true,
    description: "Stretched shoebox. Six more seats. Marginally less ugly.",
  
    oew: 32600,
    mtow: 55420,
    mlw: 48770,
    minRunway: 4000,
    image: "./aircraft/shorts-360.png",},
  "Let-410UVP": {
    model: "L-410UVP",
    manufacturer: "Let Kunovice",
    category: "regional",
    capacity: 19,
    range: 820,
    cruiseSpeed: 200,
    fuelBurn: 420,
    purchasePrice: 1500000,
    leasePrice: 18000,
    operatingCost: 2200,
    tier: 1,
    description: "Czech bush plane. Will land anywhere. Still in production.",
  
    oew: 26650,
    mtow: 45305,
    mlw: 39868,
    minRunway: 4000,
    image: "./aircraft/let-410uvp.png",},
  "EMB-110": {
    model: "EMB 110",
    manufacturer: "Embraer",
    category: "regional",
    capacity: 21,
    range: 1060,
    cruiseSpeed: 225,
    fuelBurn: 480,
    purchasePrice: 1800000,
    leasePrice: 22000,
    operatingCost: 2500,
    tier: 1,
    retired: true,
    description: "Brazil's first. Started Embraer's empire. 500+ built.",
  
    oew: 27350,
    mtow: 46495,
    mlw: 40916,
    minRunway: 4000,
    image: "./aircraft/emb-110.png",},
  "EMB-120": {
    model: "EMB 120",
    manufacturer: "Embraer",
    category: "regional",
    capacity: 30,
    range: 1020,
    cruiseSpeed: 300,
    fuelBurn: 620,
    purchasePrice: 3500000,
    leasePrice: 42000,
    operatingCost: 3800,
    tier: 1,
    description: "T-tail beauty. Pressurized. SkyWest still flies them.",
  
    oew: 30500,
    mtow: 51850,
    mlw: 45628,
    minRunway: 4000,
    image: "./aircraft/emb-120.png",},
  "YS-11": {
    model: "YS-11",
    manufacturer: "NAMC",
    category: "regional",
    capacity: 64,
    range: 680,
    cruiseSpeed: 281,
    fuelBurn: 820,
    purchasePrice: 3200000,
    leasePrice: 38000,
    operatingCost: 4200,
    tier: 1,
    retired: true,
    description: "Japan's first postwar airliner. National pride project.",
  
    oew: 42400,
    mtow: 72080,
    mlw: 63430,
    minRunway: 5500,
    image: "./aircraft/ys-11.png",},
  "Metro-III": {
    model: "Metro III",
    manufacturer: "Fairchild",
    category: "regional",
    capacity: 19,
    range: 600,
    cruiseSpeed: 290,
    fuelBurn: 420,
    purchasePrice: 1600000,
    leasePrice: 19000,
    operatingCost: 2400,
    tier: 1,
    retired: true,
    description: "The tube with wings. Passengers crawled to their seats.",
  
    oew: 26650,
    mtow: 45305,
    mlw: 39868,
    minRunway: 4000,
    image: "./aircraft/metro-iii.png",},
  "Do-328": {
    model: "Do 328",
    manufacturer: "Dornier",
    category: "regional",
    capacity: 33,
    range: 1060,
    cruiseSpeed: 335,
    fuelBurn: 750,
    purchasePrice: 4200000,
    leasePrice: 48000,
    operatingCost: 4100,
    tier: 1,
    retired: true,
    description: "German precision turboprop. Advanced wing design.",
  
    oew: 31550,
    mtow: 53635,
    mlw: 47199,
    minRunway: 4000,
    image: "./aircraft/do-328.png",},
  "Do-328JET": {
    model: "Do 328JET",
    manufacturer: "Fairchild Dornier",
    category: "regional",
    capacity: 34,
    range: 1450,
    cruiseSpeed: 400,
    fuelBurn: 1100,
    purchasePrice: 6500000,
    leasePrice: 65000,
    operatingCost: 5200,
    tier: 1,
    retired: true,
    description: "Turboprop body, jet engines. Company went bankrupt anyway.",
  
    oew: 31900,
    mtow: 54230,
    mlw: 47722,
    minRunway: 4000,
    image: "./aircraft/do-328jet.png",},
  "BAe-146-100": {
    model: "BAe 146-100",
    manufacturer: "British Aerospace",
    category: "regional",
    capacity: 82,
    range: 1520,
    cruiseSpeed: 430,
    fuelBurn: 2200,
    purchasePrice: 8500000,
    leasePrice: 95000,
    operatingCost: 6800,
    tier: 1,
    retired: true,
    description: "The Whisperjet. Four engines, incredibly quiet.",
  
    oew: 48700,
    mtow: 82790,
    mlw: 72855,
    minRunway: 5500,
    image: "./aircraft/bae-146-100.png",},
  "BAe-146-200": {
    model: "BAe 146-200",
    manufacturer: "British Aerospace",
    category: "regional",
    capacity: 100,
    range: 1670,
    cruiseSpeed: 430,
    fuelBurn: 2300,
    purchasePrice: 9500000,
    leasePrice: 105000,
    operatingCost: 7200,
    tier: 1,
    retired: true,
    description: "Stretched 146. Most popular variant.",
  
    oew: 55000,
    mtow: 93500,
    mlw: 82280,
    minRunway: 5500,
    image: "./aircraft/bae-146-200.png",},
  "BAe-146-300": {
    model: "BAe 146-300",
    manufacturer: "British Aerospace",
    category: "regional",
    capacity: 112,
    range: 1520,
    cruiseSpeed: 430,
    fuelBurn: 2400,
    purchasePrice: 10500000,
    leasePrice: 115000,
    operatingCost: 7500,
    tier: 2,
    retired: true,
    description: "Maximum stretch. Freighter conversions still flying.",
  
    oew: 59200,
    mtow: 100640,
    mlw: 88563,
    minRunway: 5500,
    image: "./aircraft/bae-146-300.png",},
  "Avro-RJ70": {
    model: "Avro RJ70",
    manufacturer: "Avro",
    category: "regional",
    capacity: 82,
    range: 1650,
    cruiseSpeed: 430,
    fuelBurn: 2100,
    purchasePrice: 11000000,
    leasePrice: 120000,
    operatingCost: 6500,
    tier: 2,
    retired: true,
    description: "146 reborn. Digital cockpit, better engines.",
  
    oew: 48700,
    mtow: 82790,
    mlw: 72855,
    minRunway: 5500,
    image: "./aircraft/avro-rj70.png",},
  "Avro-RJ85": {
    model: "Avro RJ85",
    manufacturer: "Avro",
    category: "regional",
    capacity: 93,
    range: 1800,
    cruiseSpeed: 430,
    fuelBurn: 2200,
    purchasePrice: 12000000,
    leasePrice: 130000,
    operatingCost: 6900,
    tier: 2,
    retired: true,
    description: "Middle child RJ. Swiss loved them for Alpine ops.",
  
    oew: 52550,
    mtow: 89335,
    mlw: 78615,
    minRunway: 5500,
    image: "./aircraft/avro-rj85.png",},
  "Avro-RJ100": {
    model: "Avro RJ100",
    manufacturer: "Avro",
    category: "regional",
    capacity: 112,
    range: 1650,
    cruiseSpeed: 430,
    fuelBurn: 2350,
    purchasePrice: 13000000,
    leasePrice: 140000,
    operatingCost: 7200,
    tier: 2,
    retired: true,
    description: "Full stretch. Last of the line.",
  
    oew: 59200,
    mtow: 100640,
    mlw: 88563,
    minRunway: 5500,
    image: "./aircraft/avro-rj100.png",},
  "Fokker-F27-500": {
    model: "F27-500",
    manufacturer: "Fokker",
    category: "regional",
    capacity: 52,
    range: 1200,
    cruiseSpeed: 298,
    fuelBurn: 800,
    purchasePrice: 3200000,
    leasePrice: 38000,
    operatingCost: 3800,
    tier: 1,
    retired: true,
    description: "The Friendship. 786 built. Dutch reliability.",
  
    oew: 38200,
    mtow: 64940,
    mlw: 57147,
    minRunway: 5500,
    image: "./aircraft/fokker-f27-500.png",},
  "Fokker-F28-4000": {
    model: "F28-4000",
    manufacturer: "Fokker",
    category: "regional",
    capacity: 85,
    range: 1090,
    cruiseSpeed: 430,
    fuelBurn: 2100,
    purchasePrice: 6500000,
    leasePrice: 72000,
    operatingCost: 5800,
    tier: 1,
    retired: true,
    description: "Dutch regional jet. USAir Shuttle workhorse.",
  
    oew: 49750,
    mtow: 84575,
    mlw: 74426,
    minRunway: 5500,
    image: "./aircraft/fokker-f28-4000.png",},
  "Fokker-50": {
    model: "Fokker 50",
    manufacturer: "Fokker",
    category: "regional",
    capacity: 58,
    range: 1450,
    cruiseSpeed: 320,
    fuelBurn: 850,
    purchasePrice: 5500000,
    leasePrice: 58000,
    operatingCost: 4200,
    tier: 1,
    retired: true,
    description: "F27 modernized. Glass cockpit, new engines.",
  
    oew: 40300,
    mtow: 68510,
    mlw: 60289,
    minRunway: 5500,
    image: "./aircraft/fokker-50.png",},
  "Fokker-70": {
    model: "Fokker 70",
    manufacturer: "Fokker",
    category: "regional",
    capacity: 80,
    range: 1280,
    cruiseSpeed: 430,
    fuelBurn: 1900,
    purchasePrice: 8500000,
    leasePrice: 92000,
    operatingCost: 5500,
    tier: 1,
    retired: true,
    description: "Baby Fokker. Shortened F100. KLM cityhopper's favorite.",
  
    oew: 48000,
    mtow: 81600,
    mlw: 71808,
    minRunway: 5500,
    image: "./aircraft/fokker-70.png",},
  "Fokker-100": {
    model: "Fokker 100",
    manufacturer: "Fokker",
    category: "regional",
    capacity: 109,
    range: 1680,
    cruiseSpeed: 430,
    fuelBurn: 2200,
    purchasePrice: 12000000,
    leasePrice: 125000,
    operatingCost: 6200,
    tier: 2,
    retired: true,
    description: "Fokker's last hurrah. American Airlines bought 75.",
  
    oew: 58150,
    mtow: 98855,
    mlw: 86992,
    minRunway: 5500,
    image: "./aircraft/fokker-100.png",},
  "Saab-340A": {
    model: "Saab 340A",
    manufacturer: "Saab",
    category: "regional",
    capacity: 34,
    range: 920,
    cruiseSpeed: 280,
    fuelBurn: 580,
    purchasePrice: 2800000,
    leasePrice: 32000,
    operatingCost: 3200,
    tier: 1,
    retired: true,
    description: "Swedish precision. American Eagle everywhere.",
  
    oew: 31900,
    mtow: 54230,
    mlw: 47722,
    minRunway: 4000,
    image: "./aircraft/saab-340a.png",},
  "Saab-340B": {
    model: "Saab 340B",
    manufacturer: "Saab",
    category: "regional",
    capacity: 37,
    range: 1100,
    cruiseSpeed: 290,
    fuelBurn: 620,
    purchasePrice: 3500000,
    leasePrice: 38000,
    operatingCost: 3500,
    tier: 1,
    retired: true,
    description: "More power, more seats. Still flying worldwide.",
  
    oew: 32950,
    mtow: 56015,
    mlw: 49293,
    minRunway: 4000,
    image: "./aircraft/saab-340b.png",},
  "Saab-2000": {
    model: "Saab 2000",
    manufacturer: "Saab",
    category: "regional",
    capacity: 50,
    range: 1400,
    cruiseSpeed: 370,
    fuelBurn: 850,
    purchasePrice: 6500000,
    leasePrice: 68000,
    operatingCost: 4500,
    tier: 1,
    retired: true,
    description: "Fastest turboprop ever. Jet-like speed. Only 63 built.",
  
    oew: 37500,
    mtow: 63750,
    mlw: 56100,
    minRunway: 5500,
    image: "./aircraft/saab-2000.png",},
  "Jetstream-31": {
    model: "Jetstream 31",
    manufacturer: "British Aerospace",
    category: "regional",
    capacity: 19,
    range: 680,
    cruiseSpeed: 264,
    fuelBurn: 420,
    purchasePrice: 1800000,
    leasePrice: 21000,
    operatingCost: 2600,
    tier: 1,
    retired: true,
    description: "Tiny but pressurized. United Express staple.",
  
    oew: 26650,
    mtow: 45305,
    mlw: 39868,
    minRunway: 4000,
    image: "./aircraft/jetstream-31.png",},
  "Jetstream-41": {
    model: "Jetstream 41",
    manufacturer: "British Aerospace",
    category: "regional",
    capacity: 29,
    range: 840,
    cruiseSpeed: 295,
    fuelBurn: 580,
    purchasePrice: 2800000,
    leasePrice: 32000,
    operatingCost: 3400,
    tier: 1,
    retired: true,
    description: "Stretched, modernized. Trans States workhorse.",
  
    oew: 30150,
    mtow: 51255,
    mlw: 45104,
    minRunway: 4000,
    image: "./aircraft/jetstream-41.png",},
  "DHC-6-300": {
    model: "DHC-6-300",
    manufacturer: "de Havilland Canada",
    category: "regional",
    capacity: 20,
    range: 820,
    cruiseSpeed: 180,
    fuelBurn: 340,
    purchasePrice: 3200000,
    leasePrice: 35000,
    operatingCost: 2400,
    tier: 1,
    description: "STOL legend. Beach, glacier, jungle, rooftop. Back in production.",
  
    oew: 27000,
    mtow: 45900,
    mlw: 40392,
    minRunway: 4000,
    image: "./aircraft/dhc-6-300.png",},
  "DHC-7": {
    model: "DHC-7",
    manufacturer: "de Havilland Canada",
    category: "regional",
    capacity: 50,
    range: 690,
    cruiseSpeed: 230,
    fuelBurn: 920,
    purchasePrice: 4500000,
    leasePrice: 48000,
    operatingCost: 4800,
    tier: 1,
    retired: true,
    description: "Four-engine STOL. London City's reason for existence.",
  
    oew: 37500,
    mtow: 63750,
    mlw: 56100,
    minRunway: 5500,
    image: "./aircraft/dhc-7.png",},
  "Dash-8-100": {
    model: "Dash 8-100",
    manufacturer: "de Havilland Canada",
    category: "regional",
    capacity: 37,
    range: 1020,
    cruiseSpeed: 310,
    fuelBurn: 680,
    purchasePrice: 4500000,
    leasePrice: 48000,
    operatingCost: 3600,
    tier: 1,
    retired: true,
    description: "Original Dash 8. T-tail classic.",
  
    oew: 32950,
    mtow: 56015,
    mlw: 49293,
    minRunway: 4000,
    image: "./aircraft/dash-8-100.png",},
  "Dash-8-200": {
    model: "Dash 8-200",
    manufacturer: "de Havilland Canada",
    category: "regional",
    capacity: 39,
    range: 1080,
    cruiseSpeed: 340,
    fuelBurn: 720,
    purchasePrice: 5200000,
    leasePrice: 52000,
    operatingCost: 3800,
    tier: 1,
    retired: true,
    description: "More power. Hot and high capable.",
  
    oew: 33650,
    mtow: 57205,
    mlw: 50340,
    minRunway: 4000,
    image: "./aircraft/dash-8-200.png",},
  "Dash-8-300": {
    model: "Dash 8-300",
    manufacturer: "de Havilland Canada",
    category: "regional",
    capacity: 56,
    range: 980,
    cruiseSpeed: 330,
    fuelBurn: 850,
    purchasePrice: 6500000,
    leasePrice: 62000,
    operatingCost: 4200,
    tier: 1,
    retired: true,
    description: "Stretched. Jazz Aviation's bread and butter.",
  
    oew: 39600,
    mtow: 67320,
    mlw: 59242,
    minRunway: 5500,
    image: "./aircraft/dash-8-300.png",},
  "ATR-42-300": {
    model: "ATR 42-300",
    manufacturer: "ATR",
    category: "regional",
    capacity: 48,
    range: 720,
    cruiseSpeed: 265,
    fuelBurn: 520,
    purchasePrice: 4200000,
    leasePrice: 45000,
    operatingCost: 3200,
    tier: 1,
    retired: true,
    description: "Franco-Italian collaboration. Caribbean island hopper.",
  
    oew: 36800,
    mtow: 62560,
    mlw: 55053,
    minRunway: 4000,
    image: "./aircraft/atr-42-300.png",},
  "ATR-42-500": {
    model: "ATR 42-500",
    manufacturer: "ATR",
    category: "regional",
    capacity: 50,
    range: 830,
    cruiseSpeed: 300,
    fuelBurn: 540,
    purchasePrice: 5500000,
    leasePrice: 55000,
    operatingCost: 3400,
    tier: 1,
    description: "Six-blade props, more power. Still in production.",
  
    oew: 37500,
    mtow: 63750,
    mlw: 56100,
    minRunway: 5500,
    image: "./aircraft/atr-42-500.png",},
  "ATR-72-200": {
    model: "ATR 72-200",
    manufacturer: "ATR",
    category: "regional",
    capacity: 74,
    range: 820,
    cruiseSpeed: 280,
    fuelBurn: 680,
    purchasePrice: 7500000,
    leasePrice: 72000,
    operatingCost: 4100,
    tier: 1,
    retired: true,
    description: "Stretched ATR 42. American Eagle's turboprop backbone.",
  
    oew: 45900,
    mtow: 78030,
    mlw: 68666,
    minRunway: 5500,
    image: "./aircraft/atr-72-200.png",},
  "ATR-72-600": {
    model: "ATR 72-600",
    manufacturer: "ATR",
    category: "regional",
    capacity: 78,
    range: 900,
    cruiseSpeed: 315,
    fuelBurn: 680,
    purchasePrice: 26000000,
    leasePrice: 185000,
    operatingCost: 3900,
    tier: 1,
    description: "Best-selling turboprop in the world.",
  
    oew: 47300,
    mtow: 80410,
    mlw: 70761,
    minRunway: 5500,
    image: "./aircraft/atr-72-600.png",},

  // ============================================================================
  // BATCH 6: BOEING VARIANTS
  // ============================================================================

  "737-100": {
    model: "737-100",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 103,
    range: 1540,
    cruiseSpeed: 485,
    fuelBurn: 2900,
    purchasePrice: 5500000,
    leasePrice: 65000,
    operatingCost: 5800,
    tier: 1,
    retired: true,
    description: "The original Baby Boeing. Only 30 built. Lufthansa launch customer.",
  
    oew: 70900,
    mtow: 127620,
    mlw: 112306,
    minRunway: 7000,
    image: "./aircraft/737-100.png",},
  "737-200": {
    model: "737-200",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 130,
    range: 2370,
    cruiseSpeed: 495,
    fuelBurn: 3100,
    purchasePrice: 7500000,
    leasePrice: 82000,
    operatingCost: 6200,
    tier: 1,
    retired: true,
    description: "Stretched original. Gravel kit option for unpaved runways. 1,114 built.",
  
    oew: 79000,
    mtow: 142200,
    mlw: 125136,
    minRunway: 7000,
    image: "./aircraft/737-200.png",},
  "737-200C": {
    model: "737-200C",
    manufacturer: "Boeing",
    category: "narrowbody",
    type: "combi",
    capacity: 90,
    cargoCapacity: 15000,
    range: 2200,
    cruiseSpeed: 490,
    fuelBurn: 3200,
    purchasePrice: 6800000,
    leasePrice: 78000,
    operatingCost: 6400,
    tier: 1,
    retired: true,
    description: "Convertible. Alaska Airlines bush ops legend.",
  
    oew: 51500,
    mtow: 87550,
    mlw: 77044,
    minRunway: 7000,
    image: "./aircraft/737-200c.png",},
  "737-300": {
    model: "737-300",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 149,
    range: 2685,
    cruiseSpeed: 500,
    fuelBurn: 2800,
    purchasePrice: 15000000,
    leasePrice: 145000,
    operatingCost: 5500,
    tier: 2,
    retired: true,
    description: "First CFM56 737. Those distinctive nacelles. Southwest's growth engine.",
  
    oew: 84700,
    mtow: 152460,
    mlw: 134165,
    minRunway: 7000,
    image: "./aircraft/737-300.png",},
  "737-400": {
    model: "737-400",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 168,
    range: 2375,
    cruiseSpeed: 500,
    fuelBurn: 2950,
    purchasePrice: 18000000,
    leasePrice: 165000,
    operatingCost: 5800,
    tier: 2,
    retired: true,
    description: "Stretched -300. Tail bumper added. Piedmont launch customer.",
  
    oew: 90400,
    mtow: 162720,
    mlw: 143194,
    minRunway: 7000,
    image: "./aircraft/737-400.png",},
  "737-500": {
    model: "737-500",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 132,
    range: 2950,
    cruiseSpeed: 500,
    fuelBurn: 2650,
    purchasePrice: 14000000,
    leasePrice: 135000,
    operatingCost: 5200,
    tier: 2,
    retired: true,
    description: "The forgotten baby. -200 replacement. Only 389 built.",
  
    oew: 79600,
    mtow: 143280,
    mlw: 126086,
    minRunway: 7000,
    image: "./aircraft/737-500.png",},
  "737-600": {
    model: "737-600",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 130,
    range: 3235,
    cruiseSpeed: 515,
    fuelBurn: 2500,
    purchasePrice: 22000000,
    leasePrice: 185000,
    operatingCost: 5100,
    tier: 2,
    retired: true,
    description: "NG baby. A318 competitor that lost. Only 69 built.",
  
    oew: 79000,
    mtow: 142200,
    mlw: 125136,
    minRunway: 7000,
    image: "./aircraft/737-600.png",},
  "747-100": {
    model: "747-100",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 366,
    range: 5300,
    cruiseSpeed: 555,
    fuelBurn: 12800,
    purchasePrice: 45000000,
    leasePrice: 420000,
    operatingCost: 28000,
    tier: 4,
    retired: true,
    description: "The original Jumbo. Pan Am, January 1970. Changed aviation forever.",
  
    oew: 246400,
    mtow: 492800,
    mlw: 433664,
    minRunway: 9000,
    image: "./aircraft/747-100.png",},
  "747-100SR": {
    model: "747-100SR",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 498,
    range: 3200,
    cruiseSpeed: 555,
    fuelBurn: 13200,
    purchasePrice: 48000000,
    leasePrice: 440000,
    operatingCost: 29000,
    tier: 4,
    retired: true,
    description: "Short Range. Japanese domestic. 550 seats possible.",
  
    oew: 299200,
    mtow: 598400,
    mlw: 526592,
    minRunway: 9000,
    image: "./aircraft/747-100sr.png",},
  "747-200B": {
    model: "747-200B",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 366,
    range: 6560,
    cruiseSpeed: 555,
    fuelBurn: 12500,
    purchasePrice: 58000000,
    leasePrice: 520000,
    operatingCost: 27500,
    tier: 4,
    retired: true,
    description: "Definitive classic Jumbo. True intercontinental range.",
  
    oew: 246400,
    mtow: 492800,
    mlw: 433664,
    minRunway: 9000,
    image: "./aircraft/747-200b.png",},
  "747-300": {
    model: "747-300",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 400,
    range: 6800,
    cruiseSpeed: 555,
    fuelBurn: 12300,
    purchasePrice: 65000000,
    leasePrice: 580000,
    operatingCost: 27000,
    tier: 4,
    retired: true,
    description: "Stretched upper deck. 69 more seats up top. 81 built.",
  
    oew: 260000,
    mtow: 520000,
    mlw: 457600,
    minRunway: 9000,
    image: "./aircraft/747-300.png",},
  "747SP": {
    model: "747SP",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 276,
    range: 7650,
    cruiseSpeed: 570,
    fuelBurn: 10800,
    purchasePrice: 72000000,
    leasePrice: 620000,
    operatingCost: 25000,
    tier: 4,
    retired: true,
    description: "Special Performance. Ultra long range. Only 45 built. Unicorn.",
  
    oew: 210400,
    mtow: 420800,
    mlw: 370304,
    minRunway: 9000,
    image: "./aircraft/747sp.png",},
  "747-400D": {
    model: "747-400D",
    manufacturer: "Boeing",
    category: "heavy",
    capacity: 568,
    range: 3500,
    cruiseSpeed: 555,
    fuelBurn: 13500,
    purchasePrice: 125000000,
    leasePrice: 980000,
    operatingCost: 32000,
    tier: 5,
    retired: true,
    description: "Domestic Japan. No winglets. 19 built. ANA/JAL only.",
  
    oew: 484000,
    mtow: 1064800,
    mlw: 937024,
    minRunway: 11000,
    image: "./aircraft/747-400d.png",},
  "757-200M": {
    model: "757-200M",
    manufacturer: "Boeing",
    category: "narrowbody",
    type: "combi",
    capacity: 148,
    cargoCapacity: 35000,
    range: 3600,
    cruiseSpeed: 530,
    fuelBurn: 3200,
    purchasePrice: 48000000,
    leasePrice: 380000,
    operatingCost: 9500,
    tier: 3,
    retired: true,
    description: "Main deck cargo door. Royal Nepal's lifeline.",
  
    oew: 84400,
    mtow: 151920,
    mlw: 133690,
    minRunway: 7000,
    image: "./aircraft/757-200m.png",},
  "767-200": {
    model: "767-200",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 216,
    range: 3850,
    cruiseSpeed: 530,
    fuelBurn: 5200,
    purchasePrice: 52000000,
    leasePrice: 440000,
    operatingCost: 12500,
    tier: 3,
    retired: true,
    description: "Original twin-aisle twin. United launch, 1982.",
  
    oew: 186400,
    mtow: 372800,
    mlw: 328064,
    minRunway: 9000,
    image: "./aircraft/767-200.png",},
  "767-200ER": {
    model: "767-200ER",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 216,
    range: 6590,
    cruiseSpeed: 530,
    fuelBurn: 5400,
    purchasePrice: 65000000,
    leasePrice: 520000,
    operatingCost: 13200,
    tier: 3,
    retired: true,
    description: "Extended Range. ETOPS pioneer. First twin to cross Atlantic.",
  
    oew: 186400,
    mtow: 372800,
    mlw: 328064,
    minRunway: 9000,
    image: "./aircraft/767-200er.png",},
  "767-400ER": {
    model: "767-400ER",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 304,
    range: 5645,
    cruiseSpeed: 530,
    fuelBurn: 5800,
    purchasePrice: 95000000,
    leasePrice: 780000,
    operatingCost: 15500,
    tier: 4,
    retired: true,
    description: "Maximum stretch. Delta and United only. 37 built. Rare bird.",
  
    oew: 221600,
    mtow: 443200,
    mlw: 390016,
    minRunway: 9000,
    image: "./aircraft/767-400er.png",},

  // ============================================================================
  // BATCH 7: AIRBUS VARIANTS (store aircraft only)
  // ============================================================================

  "A300B2": {
    model: "A300B2",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 254,
    range: 2100,
    cruiseSpeed: 515,
    fuelBurn: 6200,
    purchasePrice: 42000000,
    leasePrice: 380000,
    operatingCost: 14500,
    tier: 3,
    retired: true,
    description: "The first Airbus. Air France, 1974. Europe's answer.",
  
    oew: 201600,
    mtow: 403200,
    mlw: 354816,
    minRunway: 9000,
    image: "./aircraft/a300b2.png",},
  "A300B4": {
    model: "A300B4",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 269,
    range: 3430,
    cruiseSpeed: 515,
    fuelBurn: 6400,
    purchasePrice: 48000000,
    leasePrice: 420000,
    operatingCost: 15200,
    tier: 3,
    retired: true,
    description: "Extended range. Eastern bought them cheap.",
  
    oew: 207600,
    mtow: 415200,
    mlw: 365376,
    minRunway: 9000,
    image: "./aircraft/a300b4.png",},
  "A300-600R": {
    model: "A300-600R",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 298,
    range: 4070,
    cruiseSpeed: 515,
    fuelBurn: 5800,
    purchasePrice: 65000000,
    leasePrice: 540000,
    operatingCost: 14800,
    tier: 3,
    retired: true,
    description: "Refined final version. Two-crew cockpit finally.",
  
    oew: 219200,
    mtow: 438400,
    mlw: 385792,
    minRunway: 9000,
    image: "./aircraft/a300-600r.png",},
  "A310-200": {
    model: "A310-200",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 220,
    range: 4000,
    cruiseSpeed: 515,
    fuelBurn: 4800,
    purchasePrice: 45000000,
    leasePrice: 395000,
    operatingCost: 12200,
    tier: 3,
    retired: true,
    description: "Shortened A300. First two-crew Airbus.",
  
    oew: 188000,
    mtow: 376000,
    mlw: 330880,
    minRunway: 9000,
    image: "./aircraft/a310-200.png",},
  "A310-300": {
    model: "A310-300",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 220,
    range: 5150,
    cruiseSpeed: 515,
    fuelBurn: 4900,
    purchasePrice: 52000000,
    leasePrice: 440000,
    operatingCost: 12800,
    tier: 3,
    retired: true,
    description: "Winglets added. Trim tank for balance.",
  
    oew: 188000,
    mtow: 376000,
    mlw: 330880,
    minRunway: 9000,
    image: "./aircraft/a310-300.png",},
  "A318": {
    model: "A318",
    manufacturer: "Airbus",
    category: "narrowbody",
    capacity: 117,
    range: 3250,
    cruiseSpeed: 515,
    fuelBurn: 2400,
    purchasePrice: 62000000,
    leasePrice: 480000,
    operatingCost: 7500,
    tier: 2,
    retired: true,
    description: "Baby Airbus. Lost to 737-600. Only 80 built.",
  
    oew: 75100,
    mtow: 135180,
    mlw: 118958,
    minRunway: 7000,
    image: "./aircraft/a318.png",},
  "A319neo": {
    model: "A319neo",
    manufacturer: "Airbus",
    category: "narrowbody",
    capacity: 140,
    range: 3750,
    cruiseSpeed: 515,
    fuelBurn: 2200,
    purchasePrice: 92000000,
    leasePrice: 720000,
    operatingCost: 6800,
    tier: 3,
    description: "New Engine Option. 15% better fuel burn.",
  
    oew: 82000,
    mtow: 147600,
    mlw: 129888,
    minRunway: 7000,
    image: "./aircraft/a319neo.png",},
  "A321LR": {
    model: "A321LR",
    manufacturer: "Airbus",
    category: "narrowbody",
    capacity: 206,
    range: 4000,
    cruiseSpeed: 515,
    fuelBurn: 2700,
    purchasePrice: 115000000,
    leasePrice: 920000,
    operatingCost: 8500,
    tier: 4,
    description: "Long Range. Transatlantic narrowbody. Aer Lingus pioneer.",
  
    oew: 101800,
    mtow: 183240,
    mlw: 161251,
    minRunway: 7000,
    image: "./aircraft/a321lr.png",},
  "A340-200": {
    model: "A340-200",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 261,
    range: 7450,
    cruiseSpeed: 515,
    fuelBurn: 7200,
    purchasePrice: 125000000,
    leasePrice: 980000,
    operatingCost: 19500,
    tier: 4,
    retired: true,
    description: "Short body, long legs. Only 28 built. Brunei Government VIP.",
  
    oew: 204400,
    mtow: 408800,
    mlw: 359744,
    minRunway: 9000,
    image: "./aircraft/a340-200.png",},
  "A340-300": {
    model: "A340-300",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 295,
    range: 6700,
    cruiseSpeed: 515,
    fuelBurn: 7500,
    purchasePrice: 135000000,
    leasePrice: 1050000,
    operatingCost: 20500,
    tier: 4,
    retired: true,
    description: "Original 340. Four engines, no ETOPS worries.",
  
    oew: 218000,
    mtow: 436000,
    mlw: 383680,
    minRunway: 9000,
    image: "./aircraft/a340-300.png",},
  "A340-500": {
    model: "A340-500",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 313,
    range: 9000,
    cruiseSpeed: 515,
    fuelBurn: 8200,
    purchasePrice: 185000000,
    leasePrice: 1450000,
    operatingCost: 24000,
    tier: 5,
    retired: true,
    description: "World's longest range. Singapore-Newark nonstop. 18 hours.",
  
    oew: 225200,
    mtow: 450400,
    mlw: 396352,
    minRunway: 9000,
    image: "./aircraft/a340-500.png",},
  "A340-600": {
    model: "A340-600",
    manufacturer: "Airbus",
    category: "widebody",
    capacity: 380,
    range: 7900,
    cruiseSpeed: 515,
    fuelBurn: 8800,
    purchasePrice: 195000000,
    leasePrice: 1520000,
    operatingCost: 25500,
    tier: 5,
    retired: true,
    description: "Longest fuselage ever at the time. Virgin Atlantic flagship.",
  
    oew: 252000,
    mtow: 504000,
    mlw: 443520,
    minRunway: 9000,
    image: "./aircraft/a340-600.png",},

  // ============================================================================
  // BATCH 8: OBSCURE & HISTORIC
  // ============================================================================

  "Mercure": {
    model: "Mercure",
    manufacturer: "Dassault",
    category: "narrowbody",
    capacity: 155,
    range: 1150,
    cruiseSpeed: 515,
    fuelBurn: 3200,
    purchasePrice: 8500000,
    leasePrice: 95000,
    operatingCost: 7200,
    tier: 2,
    retired: true,
    description: "French 737 killer that wasn't. Air Inter only. 10 built.",
  
    oew: 86500,
    mtow: 155700,
    mlw: 137016,
    minRunway: 7000,
    image: "./aircraft/mercure.png",},
  "Handley-Page-Herald": {
    model: "Herald",
    manufacturer: "Handley Page",
    category: "regional",
    capacity: 56,
    range: 1100,
    cruiseSpeed: 275,
    fuelBurn: 920,
    purchasePrice: 2200000,
    leasePrice: 28000,
    operatingCost: 3800,
    tier: 1,
    retired: true,
    description: "British Fokker F27 rival. Started as 4 piston engines. 50 built.",
  
    oew: 39600,
    mtow: 67320,
    mlw: 59242,
    minRunway: 5500,
    image: "./aircraft/handley-page-herald.png",},
  "Bristol-Britannia": {
    model: "Britannia",
    manufacturer: "Bristol",
    category: "widebody",
    capacity: 139,
    range: 4268,
    cruiseSpeed: 362,
    fuelBurn: 2800,
    purchasePrice: 5500000,
    leasePrice: 62000,
    operatingCost: 7800,
    tier: 2,
    retired: true,
    description: "The Whispering Giant. Turboprops so quiet. Jets won.",
  
    oew: 81700,
    mtow: 147060,
    mlw: 129413,
    minRunway: 9000,
    image: "./aircraft/bristol-britannia.png",},
  "Martin-404": {
    model: "Martin 4-0-4",
    manufacturer: "Martin",
    category: "regional",
    capacity: 40,
    range: 1080,
    cruiseSpeed: 280,
    fuelBurn: 680,
    purchasePrice: 1800000,
    leasePrice: 22000,
    operatingCost: 3200,
    tier: 1,
    retired: true,
    description: "1950s pressurized perfection. TWA and Eastern.",
  
    oew: 34000,
    mtow: 57800,
    mlw: 50864,
    minRunway: 4000,
    image: "./aircraft/martin-404.png",},
  "Lockheed-Constellation": {
    model: "L-1049",
    manufacturer: "Lockheed",
    category: "narrowbody",
    capacity: 95,
    range: 4900,
    cruiseSpeed: 305,
    fuelBurn: 1800,
    purchasePrice: 3200000,
    leasePrice: 38000,
    operatingCost: 5500,
    tier: 2,
    retired: true,
    description: "Triple tail beauty. Howard Hughes' masterpiece.",
  
    oew: 53250,
    mtow: 90525,
    mlw: 79662,
    minRunway: 7000,
    image: "./aircraft/lockheed-constellation.png",},
  "Boeing-307": {
    model: "307",
    manufacturer: "Boeing",
    category: "narrowbody",
    capacity: 33,
    range: 1750,
    cruiseSpeed: 215,
    fuelBurn: 850,
    purchasePrice: 2500000,
    leasePrice: 32000,
    operatingCost: 4200,
    tier: 1,
    retired: true,
    description: "First pressurized airliner. B-17 wings and tail. Only 10 built.",
  
    oew: 31550,
    mtow: 53635,
    mlw: 47199,
    minRunway: 7000,
    image: "./aircraft/boeing-307.png",},
  "Douglas-DC-4": {
    model: "DC-4",
    manufacturer: "Douglas",
    category: "narrowbody",
    capacity: 86,
    range: 2500,
    cruiseSpeed: 227,
    fuelBurn: 720,
    purchasePrice: 1500000,
    leasePrice: 18000,
    operatingCost: 3500,
    tier: 1,
    retired: true,
    description: "Postwar workhorse. First transatlantic landplane service.",
  
    oew: 50100,
    mtow: 85170,
    mlw: 74950,
    minRunway: 7000,
    image: "./aircraft/douglas-dc-4.png",},
  "Douglas-DC-6B": {
    model: "DC-6B",
    manufacturer: "Douglas",
    category: "narrowbody",
    capacity: 107,
    range: 3005,
    cruiseSpeed: 315,
    fuelBurn: 920,
    purchasePrice: 2800000,
    leasePrice: 32000,
    operatingCost: 4500,
    tier: 1,
    retired: true,
    description: "Best piston airliner ever made. Some still flying cargo.",
  
    oew: 72100,
    mtow: 129780,
    mlw: 114206,
    minRunway: 7000,
    image: "./aircraft/douglas-dc-6b.png",},
  "Douglas-DC-7C": {
    model: "DC-7C",
    manufacturer: "Douglas",
    category: "narrowbody",
    capacity: 99,
    range: 4100,
    cruiseSpeed: 346,
    fuelBurn: 1100,
    purchasePrice: 3500000,
    leasePrice: 42000,
    operatingCost: 5200,
    tier: 2,
    retired: true,
    description: "Ultimate piston airliner. Nonstop US-Europe. Jets killed it.",
  
    oew: 54650,
    mtow: 92905,
    mlw: 81756,
    minRunway: 7000,
    image: "./aircraft/douglas-dc-7c.png",},
  "Lockheed-Electra": {
    model: "L-188",
    manufacturer: "Lockheed",
    category: "narrowbody",
    capacity: 99,
    range: 2500,
    cruiseSpeed: 405,
    fuelBurn: 2100,
    purchasePrice: 5500000,
    leasePrice: 58000,
    operatingCost: 6200,
    tier: 2,
    retired: true,
    description: "Turboprop that scared everyone. Wing failures. P-3 Orion's daddy.",
  
    oew: 54650,
    mtow: 92905,
    mlw: 81756,
    minRunway: 7000,
    image: "./aircraft/lockheed-electra.png",},
  "Boeing-377": {
    model: "377",
    manufacturer: "Boeing",
    category: "widebody",
    capacity: 100,
    range: 4200,
    cruiseSpeed: 340,
    fuelBurn: 1800,
    purchasePrice: 4200000,
    leasePrice: 48000,
    operatingCost: 6800,
    tier: 2,
    retired: true,
    description: "Double-deck luxury. B-29 derivatives. Lower deck lounge with bar.",
  
    oew: 70000,
    mtow: 126000,
    mlw: 110880,
    minRunway: 9000,
    image: "./aircraft/boeing-377.png",},

  // ============================================================================
  // BATCH 9: CHINESE & ASIAN (store aircraft only)
  // ============================================================================

  "COMAC-C919": {
    model: "COMAC C919",
    manufacturer: "COMAC",
    category: "narrowbody",
    capacity: 168,
    range: 2950,
    cruiseSpeed: 515,
    fuelBurn: 2600,
    purchasePrice: 50000000,
    leasePrice: 395000,
    operatingCost: 7800,
    tier: 3,
    description: "China's A320 competitor. China Eastern launch customer 2023.",

    oew: 90400,
    mtow: 162720,
    mlw: 143194,
    minRunway: 7000,
    image: "./aircraft/COMAC-C919.png",},
  "ARJ21-700": {
    model: "ARJ21-700",
    manufacturer: "COMAC",
    category: "regional",
    capacity: 90,
    range: 1380,
    cruiseSpeed: 480,
    fuelBurn: 2200,
    purchasePrice: 32000000,
    leasePrice: 260000,
    operatingCost: 6200,
    tier: 2,
    description: "China's regional jet. DC-9/MD-80 heritage.",
  
    oew: 51500,
    mtow: 87550,
    mlw: 77044,
    minRunway: 5500,
    image: "./aircraft/arj21-700.png",},
  "MA60": {
    model: "MA60",
    manufacturer: "Xi'an Aircraft",
    category: "regional",
    capacity: 60,
    range: 920,
    cruiseSpeed: 280,
    fuelBurn: 750,
    purchasePrice: 12000000,
    leasePrice: 95000,
    operatingCost: 3800,
    tier: 1,
    description: "Modern Y-7. Chinese An-24 derivative.",
  
    oew: 41000,
    mtow: 69700,
    mlw: 61336,
    minRunway: 5500,
    image: "./aircraft/ma60.png",},

  // ============================================================================
  // BATCH 12: BUSINESS JETS
  // ============================================================================

  "G-IV": {
    model: "G-IV",
    manufacturer: "Gulfstream",
    category: "bizjet",
    capacity: 19,
    range: 4220,
    cruiseSpeed: 505,
    fuelBurn: 1200,
    purchasePrice: 18000000,
    leasePrice: 145000,
    operatingCost: 4200,
    tier: 3,
    retired: true,
    description: "80s executive icon. Rolls-Royce Tays. 500+ built.",
  
    oew: 11800,
    mtow: 21240,
    mlw: 18691,
    minRunway: 5000,
    image: "./aircraft/g-iv.png",},
  "G-V": {
    model: "G-V",
    manufacturer: "Gulfstream",
    category: "bizjet",
    capacity: 19,
    range: 6500,
    cruiseSpeed: 505,
    fuelBurn: 1180,
    purchasePrice: 32000000,
    leasePrice: 265000,
    operatingCost: 4500,
    tier: 3,
    retired: true,
    description: "Ultra long range pioneer. NYC-Tokyo nonstop.",
  
    oew: 11800,
    mtow: 21240,
    mlw: 18691,
    minRunway: 5000,
    image: "./aircraft/g-v.png",},
  "G550": {
    model: "G550",
    manufacturer: "Gulfstream",
    category: "bizjet",
    capacity: 19,
    range: 6750,
    cruiseSpeed: 505,
    fuelBurn: 1200,
    purchasePrice: 42000000,
    leasePrice: 345000,
    operatingCost: 4800,
    tier: 4,
    description: "Head of state favorite. 500+ delivered.",
  
    oew: 11800,
    mtow: 21240,
    mlw: 18691,
    minRunway: 5000,
    image: "./aircraft/g550.png",},
  "G650": {
    model: "G650",
    manufacturer: "Gulfstream",
    category: "bizjet",
    capacity: 19,
    range: 7000,
    cruiseSpeed: 516,
    fuelBurn: 1250,
    purchasePrice: 58000000,
    leasePrice: 480000,
    operatingCost: 5200,
    tier: 4,
    description: "Fastest civil aircraft in production. Mach 0.925.",
  
    oew: 11800,
    mtow: 21240,
    mlw: 18691,
    minRunway: 5000,
    image: "./aircraft/g650.png",},
  "G650ER": {
    model: "G650ER",
    manufacturer: "Gulfstream",
    category: "bizjet",
    capacity: 19,
    range: 7500,
    cruiseSpeed: 516,
    fuelBurn: 1280,
    purchasePrice: 66500000,
    leasePrice: 545000,
    operatingCost: 5500,
    tier: 4,
    description: "Extended Range. Singapore-San Francisco nonstop.",
  
    oew: 11800,
    mtow: 21240,
    mlw: 18691,
    minRunway: 5000,
    image: "./aircraft/g650er.png",},
  "G700": {
    model: "G700",
    manufacturer: "Gulfstream",
    category: "bizjet",
    capacity: 19,
    range: 7500,
    cruiseSpeed: 516,
    fuelBurn: 1350,
    purchasePrice: 78000000,
    leasePrice: 640000,
    operatingCost: 5800,
    tier: 5,
    description: "Largest purpose-built bizjet. Five living zones. $78M.",
  
    oew: 11800,
    mtow: 21240,
    mlw: 18691,
    minRunway: 5000,
    image: "./aircraft/g700.png",},
  "Global-Express": {
    model: "Global Express",
    manufacturer: "Bombardier",
    category: "bizjet",
    capacity: 19,
    range: 6150,
    cruiseSpeed: 505,
    fuelBurn: 1350,
    purchasePrice: 35000000,
    leasePrice: 285000,
    operatingCost: 5000,
    tier: 3,
    retired: true,
    description: "Canadian ultra-long range. Gulfstream's main rival.",
  
    oew: 11800,
    mtow: 21240,
    mlw: 18691,
    minRunway: 5000,
    image: "./aircraft/global-express.png",},
  "Global-5000": {
    model: "Global 5000",
    manufacturer: "Bombardier",
    category: "bizjet",
    capacity: 17,
    range: 5200,
    cruiseSpeed: 505,
    fuelBurn: 1250,
    purchasePrice: 42000000,
    leasePrice: 345000,
    operatingCost: 4800,
    tier: 3,
    retired: true,
    description: "Shortened Global Express. Transcontinental specialist.",
  
    oew: 11400,
    mtow: 20520,
    mlw: 18058,
    minRunway: 5000,
    image: "./aircraft/global-5000.png",},
  "Global-6000": {
    model: "Global 6000",
    manufacturer: "Bombardier",
    category: "bizjet",
    capacity: 17,
    range: 6000,
    cruiseSpeed: 505,
    fuelBurn: 1300,
    purchasePrice: 52000000,
    leasePrice: 425000,
    operatingCost: 5200,
    tier: 4,
    description: "Enhanced Global Express XRS. Vision flight deck.",
  
    oew: 11400,
    mtow: 20520,
    mlw: 18058,
    minRunway: 5000,
    image: "./aircraft/global-6000.png",},
  "Global-7500": {
    model: "Global 7500",
    manufacturer: "Bombardier",
    category: "bizjet",
    capacity: 19,
    range: 7700,
    cruiseSpeed: 516,
    fuelBurn: 1380,
    purchasePrice: 72000000,
    leasePrice: 590000,
    operatingCost: 5600,
    tier: 5,
    description: "World's largest, longest range bizjet. NYC-Hong Kong nonstop.",
  
    oew: 11800,
    mtow: 21240,
    mlw: 18691,
    minRunway: 5000,
    image: "./aircraft/global-7500.png",},
  "Global-8000": {
    model: "Global 8000",
    manufacturer: "Bombardier",
    category: "bizjet",
    capacity: 19,
    range: 8000,
    cruiseSpeed: 516,
    fuelBurn: 1400,
    purchasePrice: 78000000,
    leasePrice: 635000,
    operatingCost: 5800,
    tier: 5,
    description: "Mach 0.94. Fastest since Concorde.",
  
    oew: 11800,
    mtow: 21240,
    mlw: 18691,
    minRunway: 5000,
    image: "./aircraft/global-8000.png",},
  "Falcon-900": {
    model: "Falcon 900",
    manufacturer: "Dassault",
    category: "bizjet",
    capacity: 14,
    range: 4000,
    cruiseSpeed: 481,
    fuelBurn: 980,
    purchasePrice: 28000000,
    leasePrice: 225000,
    operatingCost: 3800,
    tier: 3,
    retired: true,
    description: "Trijet bizjet. French elegance. Fighter jet heritage.",
  
    oew: 10800,
    mtow: 19440,
    mlw: 17107,
    minRunway: 3500,
    image: "./aircraft/falcon-900.png",},
  "Falcon-900EX": {
    model: "Falcon 900EX",
    manufacturer: "Dassault",
    category: "bizjet",
    capacity: 14,
    range: 4750,
    cruiseSpeed: 481,
    fuelBurn: 1020,
    purchasePrice: 35000000,
    leasePrice: 285000,
    operatingCost: 4100,
    tier: 3,
    retired: true,
    description: "Extended range trijet. Transatlantic capable.",
  
    oew: 10800,
    mtow: 19440,
    mlw: 17107,
    minRunway: 3500,
    image: "./aircraft/falcon-900ex.png",},
  "Falcon-7X": {
    model: "Falcon 7X",
    manufacturer: "Dassault",
    category: "bizjet",
    capacity: 16,
    range: 5950,
    cruiseSpeed: 481,
    fuelBurn: 1100,
    purchasePrice: 48000000,
    leasePrice: 395000,
    operatingCost: 4500,
    tier: 4,
    description: "First all fly-by-wire bizjet. Digital from Rafale.",
  
    oew: 11200,
    mtow: 20160,
    mlw: 17741,
    minRunway: 5000,
    image: "./aircraft/falcon-7x.png",},
  "Falcon-8X": {
    model: "Falcon 8X",
    manufacturer: "Dassault",
    category: "bizjet",
    capacity: 16,
    range: 6450,
    cruiseSpeed: 481,
    fuelBurn: 1050,
    purchasePrice: 58000000,
    leasePrice: 475000,
    operatingCost: 4800,
    tier: 4,
    description: "Stretched 7X. Beijing-NYC nonstop. London City certified.",
  
    oew: 11200,
    mtow: 20160,
    mlw: 17741,
    minRunway: 5000,
    image: "./aircraft/falcon-8x.png",},
  "Falcon-10X": {
    model: "Falcon 10X",
    manufacturer: "Dassault",
    category: "bizjet",
    capacity: 19,
    range: 7500,
    cruiseSpeed: 516,
    fuelBurn: 1250,
    purchasePrice: 75000000,
    leasePrice: 615000,
    operatingCost: 5500,
    tier: 5,
    description: "Twin engine ultra long range. Widest cabin ever.",
  
    oew: 11800,
    mtow: 21240,
    mlw: 18691,
    minRunway: 5000,
    image: "./aircraft/falcon-10x.png",},
  "Citation-X": {
    model: "Citation X",
    manufacturer: "Cessna",
    category: "bizjet",
    capacity: 12,
    range: 3460,
    cruiseSpeed: 525,
    fuelBurn: 1150,
    purchasePrice: 22000000,
    leasePrice: 180000,
    operatingCost: 4200,
    tier: 3,
    retired: true,
    description: "Fastest civilian aircraft for 20 years. Mach 0.935.",
  
    oew: 10400,
    mtow: 18720,
    mlw: 16474,
    minRunway: 3500,
    image: "./aircraft/citation-x.png",},
  "Citation-Longitude": {
    model: "Citation Longitude",
    manufacturer: "Cessna",
    category: "bizjet",
    capacity: 12,
    range: 3500,
    cruiseSpeed: 483,
    fuelBurn: 920,
    purchasePrice: 27000000,
    leasePrice: 220000,
    operatingCost: 3600,
    tier: 3,
    description: "Super midsize. Flat floor, stand-up cabin.",
  
    oew: 10400,
    mtow: 18720,
    mlw: 16474,
    minRunway: 3500,
    image: "./aircraft/citation-longitude.png",},
  "Citation-Latitude": {
    model: "Citation Latitude",
    manufacturer: "Cessna",
    category: "bizjet",
    capacity: 9,
    range: 2700,
    cruiseSpeed: 446,
    fuelBurn: 780,
    purchasePrice: 18000000,
    leasePrice: 148000,
    operatingCost: 3100,
    tier: 2,
    description: "Midsize sweet spot. Best selling midsize jet.",
  
    oew: 9800,
    mtow: 17640,
    mlw: 15523,
    minRunway: 3500,
    image: "./aircraft/citation-latitude.png",},
  "Learjet-60": {
    model: "Learjet 60",
    manufacturer: "Learjet",
    category: "bizjet",
    capacity: 8,
    range: 2405,
    cruiseSpeed: 465,
    fuelBurn: 780,
    purchasePrice: 11000000,
    leasePrice: 92000,
    operatingCost: 2800,
    tier: 2,
    retired: true,
    description: "The iconic shape. Air ambulance favorite.",
  
    oew: 9600,
    mtow: 17280,
    mlw: 15206,
    minRunway: 3500,
    image: "./aircraft/learjet-60.png",},
  "Learjet-75": {
    model: "Learjet 75",
    manufacturer: "Learjet",
    category: "bizjet",
    capacity: 9,
    range: 2040,
    cruiseSpeed: 465,
    fuelBurn: 820,
    purchasePrice: 14000000,
    leasePrice: 115000,
    operatingCost: 3100,
    tier: 2,
    retired: true,
    description: "Final Learjet. Production ended 2021. 60 years of legend.",
  
    oew: 9800,
    mtow: 17640,
    mlw: 15523,
    minRunway: 3500,
    image: "./aircraft/learjet-75.png",},
  "Phenom-300E": {
    model: "Phenom 300E",
    manufacturer: "Embraer",
    category: "bizjet",
    capacity: 10,
    range: 2010,
    cruiseSpeed: 464,
    fuelBurn: 620,
    purchasePrice: 10200000,
    leasePrice: 85000,
    operatingCost: 2400,
    tier: 2,
    description: "Best-selling light jet in the world. Eight years running.",
  
    oew: 10000,
    mtow: 18000,
    mlw: 15840,
    minRunway: 3500,
    image: "./aircraft/phenom-300e.png",},
  "Praetor-600": {
    model: "Praetor 600",
    manufacturer: "Embraer",
    category: "bizjet",
    capacity: 12,
    range: 4018,
    cruiseSpeed: 466,
    fuelBurn: 950,
    purchasePrice: 21000000,
    leasePrice: 172000,
    operatingCost: 3500,
    tier: 3,
    description: "Super midsize. Fly-by-wire. NYC-London nonstop.",
  
    oew: 10400,
    mtow: 18720,
    mlw: 16474,
    minRunway: 3500,
    image: "./aircraft/praetor-600.png",},
  "Legacy-650E": {
    model: "Legacy 650E",
    manufacturer: "Embraer",
    category: "bizjet",
    capacity: 14,
    range: 3900,
    cruiseSpeed: 459,
    fuelBurn: 1150,
    purchasePrice: 26000000,
    leasePrice: 215000,
    operatingCost: 4200,
    tier: 3,
    description: "ERJ-135 derivative. Three-zone cabin.",
  
    oew: 10800,
    mtow: 19440,
    mlw: 17107,
    minRunway: 3500,
    image: "./aircraft/legacy-650e.png",},
  "PC-24": {
    model: "PC-24",
    manufacturer: "Pilatus",
    category: "bizjet",
    capacity: 10,
    range: 2000,
    cruiseSpeed: 440,
    fuelBurn: 680,
    purchasePrice: 11000000,
    leasePrice: 92000,
    operatingCost: 2600,
    tier: 2,
    description: "Super versatile jet. Unpaved runway capable. Cargo door.",
  
    oew: 10000,
    mtow: 18000,
    mlw: 15840,
    minRunway: 3500,
    image: "./aircraft/pc-24.png",},
  "HondaJet-Elite": {
    model: "HondaJet Elite",
    manufacturer: "Honda",
    category: "bizjet",
    capacity: 7,
    range: 1437,
    cruiseSpeed: 422,
    fuelBurn: 380,
    purchasePrice: 5400000,
    leasePrice: 45000,
    operatingCost: 1600,
    tier: 1,
    description: "Over-the-wing engines. Most delivered light jet.",
  
    oew: 9400,
    mtow: 16920,
    mlw: 14890,
    minRunway: 3500,
    image: "./aircraft/hondajet-elite.png",},
  "Challenger-350": {
    model: "Challenger 350",
    manufacturer: "Bombardier",
    category: "bizjet",
    capacity: 10,
    range: 3200,
    cruiseSpeed: 470,
    fuelBurn: 980,
    purchasePrice: 27000000,
    leasePrice: 220000,
    operatingCost: 3800,
    tier: 3,
    description: "Super mid workhorse. NetJets, Flexjet fleet backbone.",
  
    oew: 10000,
    mtow: 18000,
    mlw: 15840,
    minRunway: 3500,
    image: "./aircraft/challenger-350.png",},
  "Challenger-650": {
    model: "Challenger 650",
    manufacturer: "Bombardier",
    category: "bizjet",
    capacity: 12,
    range: 4000,
    cruiseSpeed: 470,
    fuelBurn: 1100,
    purchasePrice: 32000000,
    leasePrice: 262000,
    operatingCost: 4200,
    tier: 3,
    description: "Large cabin. CL-600 lineage since 1980. Reliable.",
  
    oew: 10400,
    mtow: 18720,
    mlw: 16474,
    minRunway: 3500,
    image: "./aircraft/challenger-650.png",},

  // ============================================================================
  // BATCH 14: TURBOPROPS - WORKHORSES
  // ============================================================================

  "Beech-1900D": {
    model: "1900D",
    manufacturer: "Beechcraft",
    category: "regional",
    capacity: 19,
    range: 890,
    cruiseSpeed: 280,
    fuelBurn: 420,
    purchasePrice: 3200000,
    leasePrice: 35000,
    operatingCost: 2400,
    tier: 1,
    retired: true,
    description: "T-tail regional workhorse. Stand-up cabin. 695 built.",
  
    oew: 26650,
    mtow: 45305,
    mlw: 39868,
    minRunway: 4000,
    image: "./aircraft/beech-1900d.png",},
  "Beech-99": {
    model: "Beech 99",
    manufacturer: "Beechcraft",
    category: "regional",
    capacity: 15,
    range: 1000,
    cruiseSpeed: 240,
    fuelBurn: 320,
    purchasePrice: 1200000,
    leasePrice: 15000,
    operatingCost: 1800,
    tier: 1,
    retired: true,
    description: "Commuter pioneer. Cargo pod underneath. FedEx feeder origins.",
  
    oew: 25250,
    mtow: 42925,
    mlw: 37774,
    minRunway: 4000,
    image: "./aircraft/beech-99.png",},
  "DHC-3": {
    model: "DHC-3",
    manufacturer: "de Havilland Canada",
    category: "regional",
    capacity: 11,
    range: 640,
    cruiseSpeed: 138,
    fuelBurn: 180,
    purchasePrice: 850000,
    leasePrice: 9500,
    operatingCost: 1200,
    tier: 1,
    retired: true,
    description: "King of the bush. Float or wheel. Alaska essential.",
  
    oew: 23850,
    mtow: 40545,
    mlw: 35680,
    minRunway: 4000,
    image: "./aircraft/dhc-3.png",},
  "DHC-2": {
    model: "DHC-2",
    manufacturer: "de Havilland Canada",
    category: "regional",
    capacity: 7,
    range: 455,
    cruiseSpeed: 130,
    fuelBurn: 120,
    purchasePrice: 650000,
    leasePrice: 7500,
    operatingCost: 900,
    tier: 1,
    retired: true,
    description: "Greatest bush plane ever. 1,657 built. Canada's gift to aviation.",
  
    oew: 22450,
    mtow: 38165,
    mlw: 33585,
    minRunway: 4000,
    image: "./aircraft/dhc-2.png",},
  "Caravan": {
    model: "208B",
    manufacturer: "Cessna",
    category: "regional",
    capacity: 14,
    range: 912,
    cruiseSpeed: 186,
    fuelBurn: 260,
    purchasePrice: 2800000,
    leasePrice: 28000,
    operatingCost: 1600,
    tier: 1,
    description: "FedEx feeder king. Skydiver taxi. 3,000+ built.",
  
    oew: 24900,
    mtow: 42330,
    mlw: 37250,
    minRunway: 4000,
    image: "./aircraft/caravan.png",},
  "Caravan-Amphibian": {
    model: "208 Amphibian",
    manufacturer: "Cessna",
    category: "regional",
    capacity: 10,
    range: 720,
    cruiseSpeed: 168,
    fuelBurn: 280,
    purchasePrice: 3500000,
    leasePrice: 35000,
    operatingCost: 1900,
    tier: 1,
    description: "Wipline floats. Maldives resort hopper.",
  
    oew: 23500,
    mtow: 39950,
    mlw: 35156,
    minRunway: 4000,
    image: "./aircraft/caravan-amphibian.png",},
  "King-Air-350": {
    model: "King Air 350",
    manufacturer: "Beechcraft",
    category: "regional",
    capacity: 11,
    range: 1806,
    cruiseSpeed: 312,
    fuelBurn: 420,
    purchasePrice: 8500000,
    leasePrice: 72000,
    operatingCost: 2200,
    tier: 2,
    description: "Turboprop executive. 7,600+ King Airs built total.",
  
    oew: 23850,
    mtow: 40545,
    mlw: 35680,
    minRunway: 4000,
    image: "./aircraft/king-air-350.png",},
  "PC-12": {
    model: "PC-12",
    manufacturer: "Pilatus",
    category: "regional",
    capacity: 9,
    range: 1845,
    cruiseSpeed: 285,
    fuelBurn: 320,
    purchasePrice: 5500000,
    leasePrice: 48000,
    operatingCost: 1800,
    tier: 1,
    description: "Swiss army knife. Executive, cargo, medevac. 1,800+ sold.",
  
    oew: 23150,
    mtow: 39355,
    mlw: 34632,
    minRunway: 4000,
    image: "./aircraft/pc-12.png",},
  "TBM-940": {
    model: "TBM 940",
    manufacturer: "Daher",
    category: "regional",
    capacity: 6,
    range: 1730,
    cruiseSpeed: 330,
    fuelBurn: 280,
    purchasePrice: 4200000,
    leasePrice: 38000,
    operatingCost: 1500,
    tier: 1,
    description: "Fastest single turboprop. 330 knots. French engineering.",
  
    oew: 22100,
    mtow: 37570,
    mlw: 33062,
    minRunway: 4000,
    image: "./aircraft/tbm-940.png",},
  "Quest-Kodiak": {
    model: "Kodiak 100",
    manufacturer: "Daher",
    category: "regional",
    capacity: 10,
    range: 1132,
    cruiseSpeed: 183,
    fuelBurn: 220,
    purchasePrice: 2200000,
    leasePrice: 22000,
    operatingCost: 1400,
    tier: 1,
    description: "Modern bush plane. 1,000 ft takeoff. Beaver successor.",
  
    oew: 23500,
    mtow: 39950,
    mlw: 35156,
    minRunway: 4000,
    image: "./aircraft/quest-kodiak.png",},
  "BN-2": {
    model: "BN-2",
    manufacturer: "Britten-Norman",
    category: "regional",
    capacity: 9,
    range: 780,
    cruiseSpeed: 150,
    fuelBurn: 160,
    purchasePrice: 850000,
    leasePrice: 9500,
    operatingCost: 950,
    tier: 1,
    description: "Scottish islands, Caribbean beaches. 1,200+ built.",
  
    oew: 23150,
    mtow: 39355,
    mlw: 34632,
    minRunway: 4000,
    image: "./aircraft/bn-2.png",},
  "Trislander": {
    model: "Trislander",
    manufacturer: "Britten-Norman",
    category: "regional",
    capacity: 17,
    range: 640,
    cruiseSpeed: 150,
    fuelBurn: 220,
    purchasePrice: 1200000,
    leasePrice: 14000,
    operatingCost: 1200,
    tier: 1,
    retired: true,
    description: "Three engines. That weird tail-mounted one. Aurigny legend.",
  
    oew: 25950,
    mtow: 44115,
    mlw: 38821,
    minRunway: 4000,
    image: "./aircraft/trislander.png",},

  // ============================================================================
  // NEW COLLECTIBLES - January 2026 Batch
  // ============================================================================

  // --- RARE TIER ---
  "dornier-228-new": {
    model: "Dornier 228",
    manufacturer: "Dornier",
    category: "collectible",
    rarity: "rare",
    tagline: "German STOL specialist.",
    capacity: 19,
    range: 700,
    cruiseSpeed: 220,
    fuelBurn: 300,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/dornier-228.png",
  },
  "il-114-new": {
    model: "Ilyushin Il-114",
    manufacturer: "Ilyushin",
    category: "collectible",
    rarity: "rare",
    tagline: "Russia's ATR answer.",
    capacity: 64,
    range: 1500,
    cruiseSpeed: 270,
    fuelBurn: 680,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/il-114.png",
  },
  "iptn-n219": {
    model: "IPTN N-219",
    manufacturer: "Indonesian Aerospace",
    category: "collectible",
    rarity: "rare",
    tagline: "Indonesian island hopper.",
    capacity: 19,
    range: 600,
    cruiseSpeed: 195,
    fuelBurn: 250,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/n219.png",
  },
  "cn-235-new": {
    model: "CN-235",
    manufacturer: "CASA/IPTN",
    category: "collectible",
    rarity: "rare",
    tagline: "Spanish-Indonesian partnership.",
    capacity: 44,
    range: 1500,
    cruiseSpeed: 245,
    fuelBurn: 600,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/cn-235.png",
  },
  "harbin-y-12": {
    model: "Harbin Y-12",
    manufacturer: "Harbin",
    category: "collectible",
    rarity: "rare",
    tagline: "China's bush plane.",
    capacity: 17,
    range: 700,
    cruiseSpeed: 180,
    fuelBurn: 280,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/y-12.png",
  },
  "casa-212-new": {
    model: "CASA C-212 Aviocar",
    manufacturer: "CASA",
    category: "collectible",
    rarity: "rare",
    tagline: "Spanish utility truck of the sky.",
    capacity: 26,
    range: 780,
    cruiseSpeed: 190,
    fuelBurn: 400,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/casa-212.png",
  },
  "l-410-ng-new": {
    model: "L-410 NG",
    manufacturer: "Aircraft Industries",
    category: "collectible",
    rarity: "rare",
    tagline: "Czech classic. Now with glass cockpit.",
    capacity: 19,
    range: 800,
    cruiseSpeed: 215,
    fuelBurn: 300,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/l-410-ng.png",
  },
  "an-26-new": {
    model: "Antonov An-26",
    manufacturer: "Antonov",
    category: "collectible",
    rarity: "rare",
    tagline: "The cargo An-24. Rear ramp included.",
    capacity: 40,
    range: 1100,
    cruiseSpeed: 235,
    fuelBurn: 850,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/an-26.png",
  },
  "yak-40-new": {
    model: "Yakovlev Yak-40",
    manufacturer: "Yakovlev",
    category: "collectible",
    rarity: "rare",
    tagline: "Three jets for the proletariat.",
    capacity: 32,
    range: 900,
    cruiseSpeed: 340,
    fuelBurn: 1200,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/yak-40.png",
  },
  "erj-135-new": {
    model: "ERJ-135",
    manufacturer: "Embraer",
    category: "collectible",
    rarity: "rare",
    tagline: "Brazilian baby jet.",
    capacity: 37,
    range: 1750,
    cruiseSpeed: 470,
    fuelBurn: 1400,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/erj-135.png",
  },
  "erj-145-new": {
    model: "ERJ-145",
    manufacturer: "Embraer",
    category: "collectible",
    rarity: "rare",
    tagline: "The commuter jet revolution.",
    capacity: 50,
    range: 1850,
    cruiseSpeed: 475,
    fuelBurn: 1600,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/erj-145.png",
  },
  "xian-ma700": {
    model: "Xian MA700",
    manufacturer: "AVIC",
    category: "collectible",
    rarity: "rare",
    tagline: "China's next-gen turboprop.",
    capacity: 86,
    range: 1500,
    cruiseSpeed: 340,
    fuelBurn: 900,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/ma700.png",
  },
  "atr-42-600-new": {
    model: "ATR 42-600",
    manufacturer: "ATR",
    category: "collectible",
    rarity: "rare",
    tagline: "Latest generation. Glass cockpit.",
    capacity: 48,
    range: 1330,
    cruiseSpeed: 300,
    fuelBurn: 480,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/atr-42-600.png",
  },
  "q400-new": {
    model: "De Havilland Q400",
    manufacturer: "De Havilland Canada",
    category: "collectible",
    rarity: "rare",
    tagline: "Speed of a jet. Economy of a turboprop.",
    capacity: 78,
    range: 1558,
    cruiseSpeed: 360,
    fuelBurn: 850,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/q400.png",
  },
  "e175-e2-new": {
    model: "E175-E2",
    manufacturer: "Embraer",
    category: "collectible",
    rarity: "rare",
    tagline: "The E2 family's baby.",
    capacity: 88,
    range: 2600,
    cruiseSpeed: 490,
    fuelBurn: 1700,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/e175-e2.png",
  },
  "e190-e2-new": {
    model: "E190-E2",
    manufacturer: "Embraer",
    category: "collectible",
    rarity: "rare",
    tagline: "Profit Hunter. Wideroe's choice.",
    capacity: 106,
    range: 3050,
    cruiseSpeed: 495,
    fuelBurn: 1900,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/e190-e2.png",
  },
  "e195-e2-new": {
    model: "E195-E2",
    manufacturer: "Embraer",
    category: "collectible",
    rarity: "rare",
    tagline: "Biggest E2. Narrowbody competitor.",
    capacity: 146,
    range: 2600,
    cruiseSpeed: 500,
    fuelBurn: 2200,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/e195-e2.png",
  },
  "a220-100-new": {
    model: "Airbus A220-100",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "rare",
    tagline: "The CSeries reborn.",
    capacity: 135,
    range: 3400,
    cruiseSpeed: 505,
    fuelBurn: 2100,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/a220-100.png",
  },
  "viking-dhc-6-400": {
    model: "Viking DHC-6-400 Twin Otter",
    manufacturer: "Viking Air",
    category: "collectible",
    rarity: "rare",
    tagline: "The legend reborn.",
    capacity: 19,
    range: 750,
    cruiseSpeed: 185,
    fuelBurn: 290,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/dhc-6-400.png",
  },
  "gulfstream-g280": {
    model: "Gulfstream G280",
    manufacturer: "Gulfstream",
    category: "collectible",
    rarity: "rare",
    tagline: "Super-midsize pioneer.",
    capacity: 10,
    range: 3600,
    cruiseSpeed: 482,
    fuelBurn: 850,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/g280.png",
  },
  "dc-9-10-new": {
    model: "DC-9-10",
    manufacturer: "Douglas",
    category: "collectible",
    rarity: "rare",
    tagline: "The original baby Douglas.",
    capacity: 90,
    range: 1700,
    cruiseSpeed: 460,
    fuelBurn: 2800,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/dc-9-10.png",
  },
  "bbj-max-7-new": {
    model: "Boeing BBJ MAX 7",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "737 MAX for billionaires.",
    capacity: 40,
    range: 7000,
    cruiseSpeed: 520,
    fuelBurn: 3500,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/bbj-max-7.png",
  },
  "bbj-max-8-new": {
    model: "Boeing BBJ MAX 8",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "VIP MAX. Government favorite.",
    capacity: 50,
    range: 6600,
    cruiseSpeed: 520,
    fuelBurn: 3800,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/bbj-max-8.png",
  },
  "acj320neo": {
    model: "Airbus ACJ320neo",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "rare",
    tagline: "A320neo for royalty.",
    capacity: 25,
    range: 6000,
    cruiseSpeed: 515,
    fuelBurn: 3200,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/acj320neo.png",
  },
  "embraer-lineage-1000e": {
    model: "Embraer Lineage 1000E",
    manufacturer: "Embraer",
    category: "collectible",
    rarity: "rare",
    tagline: "E190 for executives.",
    capacity: 19,
    range: 4600,
    cruiseSpeed: 500,
    fuelBurn: 2000,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/lineage-1000e.png",
  },
  "pc-12-ngx": {
    model: "Pilatus PC-12 NGX",
    manufacturer: "Pilatus",
    category: "collectible",
    rarity: "rare",
    tagline: "Single-engine perfection.",
    capacity: 9,
    range: 1800,
    cruiseSpeed: 290,
    fuelBurn: 290,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/pc-12-ngx.png",
  },
  "tbm-960": {
    model: "Daher TBM 960",
    manufacturer: "Daher",
    category: "collectible",
    rarity: "rare",
    tagline: "Fastest single turboprop.",
    capacity: 6,
    range: 1730,
    cruiseSpeed: 330,
    fuelBurn: 250,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/tbm-960.png",
  },
  "king-air-360": {
    model: "Beechcraft King Air 360",
    manufacturer: "Textron Aviation",
    category: "collectible",
    rarity: "rare",
    tagline: "Twin turboprop royalty.",
    capacity: 11,
    range: 1806,
    cruiseSpeed: 312,
    fuelBurn: 550,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/king-air-360.png",
  },
  "c-295-new": {
    model: "Airbus C-295",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "rare",
    tagline: "Tactical airlifter. CN-235's big brother.",
    capacity: 71,
    range: 4600,
    cruiseSpeed: 260,
    fuelBurn: 700,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/c-295.png",
  },
  "e-6b-mercury": {
    model: "E-6B Mercury",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "Nuclear command post. TACAMO.",
    capacity: 22,
    range: 6600,
    cruiseSpeed: 510,
    fuelBurn: 5500,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/e-6b.png",
  },
  "cr929": {
    model: "CRAIC CR929",
    manufacturer: "CRAIC",
    category: "collectible",
    rarity: "rare",
    tagline: "Sino-Russian widebody dream.",
    capacity: 290,
    range: 12000,
    cruiseSpeed: 530,
    fuelBurn: 7500,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/cr929.png",
  },
  "c929": {
    model: "COMAC C929",
    manufacturer: "COMAC",
    category: "collectible",
    rarity: "rare",
    tagline: "China's widebody independence.",
    capacity: 280,
    range: 12000,
    cruiseSpeed: 530,
    fuelBurn: 7000,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/c929.png",
  },
  "sj100": {
    model: "Sukhoi SJ-100",
    manufacturer: "Sukhoi",
    category: "collectible",
    rarity: "rare",
    tagline: "Superjet goes fully Russian.",
    capacity: 100,
    range: 3000,
    cruiseSpeed: 485,
    fuelBurn: 2600,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/sj100.png",
  },
  "bbj-777x": {
    model: "Boeing BBJ 777X",
    manufacturer: "Boeing",
    category: "collectible",
    rarity: "rare",
    tagline: "Flying palace. Folding wingtips.",
    capacity: 75,
    range: 11000,
    cruiseSpeed: 550,
    fuelBurn: 8500,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/rare/bbj-777x.png",
  },

  // --- LEGENDARY TIER ---
  "an-72": {
    model: "Antonov An-72",
    manufacturer: "Antonov",
    category: "collectible",
    rarity: "legendary",
    tagline: "Engines over wings. STOL master.",
    capacity: 68,
    range: 800,
    cruiseSpeed: 350,
    fuelBurn: 2000,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/legendary/an-72.png",
  },
  "an-74": {
    model: "Antonov An-74",
    manufacturer: "Antonov",
    category: "collectible",
    rarity: "legendary",
    tagline: "Arctic specialist.",
    capacity: 52,
    range: 1150,
    cruiseSpeed: 360,
    fuelBurn: 2100,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/legendary/an-74.png",
  },
  "cirrus-sf50": {
    model: "Cirrus SF50 Vision Jet",
    manufacturer: "Cirrus",
    category: "collectible",
    rarity: "legendary",
    tagline: "Personal jet. Parachute included.",
    capacity: 7,
    range: 1200,
    cruiseSpeed: 311,
    fuelBurn: 300,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/legendary/sf50.png",
  },
  "eviation-alice": {
    model: "Eviation Alice",
    manufacturer: "Eviation",
    category: "collectible",
    rarity: "legendary",
    tagline: "All-electric commuter.",
    capacity: 9,
    range: 440,
    cruiseSpeed: 260,
    fuelBurn: 0,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/legendary/eviation-alice.png",
  },
  "flying-v": {
    model: "KLM Flying-V",
    manufacturer: "TU Delft/KLM",
    category: "collectible",
    rarity: "legendary",
    tagline: "V-shaped flying wing. Dutch innovation.",
    capacity: 314,
    range: 8000,
    cruiseSpeed: 530,
    fuelBurn: 4200,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/legendary/flying-v.png",
  },
  "airbus-zeroe": {
    model: "Airbus ZEROe",
    manufacturer: "Airbus",
    category: "collectible",
    rarity: "legendary",
    tagline: "Hydrogen-powered. Zero emissions by 2035.",
    capacity: 200,
    range: 2000,
    cruiseSpeed: 480,
    fuelBurn: 0,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/legendary/zeroe.png",
  },
  "hermeus-quarterhorse": {
    model: "Hermeus Quarterhorse",
    manufacturer: "Hermeus",
    category: "collectible",
    rarity: "legendary",
    tagline: "Mach 5 demonstrator. Hypersonic future.",
    capacity: 20,
    range: 4000,
    cruiseSpeed: 3300,
    fuelBurn: 50000,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/legendary/quarterhorse.png",
  },

  // --- ANOMALOUS TIER ---
  "zero-divided-by-zero": {
    model: "0/0",
    manufacturer: "???",
    category: "collectible",
    rarity: "anomalous",
    tagline: "NaN. Not a Number. Not a plane.",
    capacity: NaN,
    range: Infinity,
    cruiseSpeed: 0,
    fuelBurn: -1,
    purchasePrice: 0,
    leasePrice: null,
    operatingCost: 0,
    tier: 5,
    image: "./aircraft/collectibles/anomalous/zero-divided-by-zero.png",
    anomalousBehavior: "zero_division",
  
    specialEffect: "Undefined behavior - random outcomes on each flight",},
};

// ============================================================================
// BACKWARD COMPATIBILITY ALIASES (for existing saves with old aircraft keys)
// These ensure players don't lose aircraft when we rename registry keys
// ============================================================================
AIRCRAFT_DATABASE["E170"] = AIRCRAFT_DATABASE["Embraer-E170"];
AIRCRAFT_DATABASE["E175"] = AIRCRAFT_DATABASE["Embraer-E175"];
AIRCRAFT_DATABASE["E190"] = AIRCRAFT_DATABASE["Embraer-E190"];
AIRCRAFT_DATABASE["E195"] = AIRCRAFT_DATABASE["Embraer-E195"];
AIRCRAFT_DATABASE["C919"] = AIRCRAFT_DATABASE["COMAC-C919"];

// ============================================================================
// IMAGE PATH MAPPING (for components that need to look up by model name)
// ============================================================================

export const AIRCRAFT_IMAGES = {
  // Regional
  'E170': './aircraft/e170.png',
  'E175': './aircraft/e175.png',
  'E190': './aircraft/e190.png',
  'E195': './aircraft/e195.png',
  'CRJ700': './aircraft/crj700.png',
  'CRJ-700': './aircraft/crj700.png',
  'CRJ900': './aircraft/crj900.png',
  'CRJ-900': './aircraft/crj900.png',
  'A220-300': './aircraft/a220-300.png',
  
  // Narrowbody
  'A319': './aircraft/a319.png',
  'A320': './aircraft/a320.png',
  'A320neo': './aircraft/a320neo.png',
  'A321': './aircraft/a321.png',
  'A321XLR': './aircraft/a321xlr.png',
  'B737-700': './aircraft/b737-700.png',
  '737-700': './aircraft/b737-700.png',
  'B737-800': './aircraft/b737-800.png',
  '737-800': './aircraft/b737-800.png',
  'B737-900ER': './aircraft/b737-900er.png',
  '737-900ER': './aircraft/b737-900er.png',
  'B737MAX8': './aircraft/b737max8.png',
  '737 MAX 8': './aircraft/b737max8.png',
  'B737MAX9': './aircraft/b737max9.png',
  '737 MAX 9': './aircraft/b737max9.png',
  'B757-200': './aircraft/b757-200.png',
  '757-200': './aircraft/b757-200.png',
  'B757-300': './aircraft/b757-300.png',
  '757-300': './aircraft/b757-300.png',
  
  // Widebody
  'A330-200': './aircraft/a330-200.png',
  'A330-300': './aircraft/a330-300.png',
  'A330-900neo': './aircraft/a330-900neo.png',
  'A350-900': './aircraft/a350-900.png',
  'A350-1000': './aircraft/a350-1000.png',
  'A380': './aircraft/a380.png',
  'A380-800': './aircraft/a380.png',
  'B747-8': './aircraft/b747-8.png',
  '747-8': './aircraft/b747-8.png',
  'B767-300ER': './aircraft/b767-300er.png',
  '767-300ER': './aircraft/b767-300er.png',
  'B777-200ER': './aircraft/b777-200er.png',
  '777-200ER': './aircraft/b777-200er.png',
  'B777-300ER': './aircraft/b777-300er.png',
  '777-300ER': './aircraft/b777-300er.png',
  'B787-8': './aircraft/b787-8.png',
  '787-8': './aircraft/b787-8.png',
  'B787-9': './aircraft/b787-9.png',
  '787-9': './aircraft/b787-9.png',
  'B787-10': './aircraft/b787-10.png',
  '787-10': './aircraft/b787-10.png',
   // Classic Jets
  '707-120': './aircraft/707-120.png',
  '707-320B': './aircraft/707-320b.png',
  '720': './aircraft/720.png',
  '727-100': './aircraft/727-100.png',
  '727-200': './aircraft/727-200.png',
  '727-200F': './aircraft/727-200f.png',
  '737-100': './aircraft/737-100.png',
  '737-200': './aircraft/737-200.png',
  '737-200C': './aircraft/737-200c.png',
  '737-300': './aircraft/737-300.png',
  '737-400': './aircraft/737-400.png',
  '737-500': './aircraft/737-500.png',
  '737-600': './aircraft/737-600.png',
  
  // Boeing Widebody
  '747-100': './aircraft/747-100.png',
  '747-100SR': './aircraft/747-100sr.png',
  '747-200B': './aircraft/747-200b.png',
  '747-200F': './aircraft/747-200f.png',
  '747-300': './aircraft/747-300.png',
  '747-400BCF': './aircraft/747-400bcf.png',
  '747-400D': './aircraft/747-400d.png',
  '747SP': './aircraft/747sp.png',
  '747X': './aircraft/747x.png',
  '757-200M': './aircraft/757-200m.png',
  '757-200PF': './aircraft/757-200pf.png',
  '767-200': './aircraft/767-200.png',
  '767-200ER': './aircraft/767-200er.png',
  '767-400ER': './aircraft/767-400er.png',
  
  // Airbus
  'A300B2': './aircraft/a300b2.png',
  'A300B4': './aircraft/a300b4.png',
  'A300-600R': './aircraft/a300-600r.png',
  'A300-600F': './aircraft/a300-600f.png',
  'A300-600ST': './aircraft/a300-600st.png',
  'A310-200': './aircraft/a310-200.png',
  'A310-300': './aircraft/a310-300.png',
  'A318': './aircraft/a318.png',
  'A319neo': './aircraft/a319neo.png',
  'A321LR': './aircraft/a321lr.png',
  'A330-200F': './aircraft/a330-200f.png',
  'A330-743L': './aircraft/a330-743l.png',
  'A340-200': './aircraft/a340-200.png',
  'A340-300': './aircraft/a340-300.png',
  'A340-500': './aircraft/a340-500.png',
  'A340-600': './aircraft/a340-600.png',
  'A340-8000': './aircraft/a340-8000.png',
  'A380-800F': './aircraft/a380-800f.png',
  'A380neo': './aircraft/a380neo.png',
  'A400M': './aircraft/a400m.png',
  'A2000': './aircraft/a2000.png',
  
  // Soviet/Russian
  'Tu-104A': './aircraft/tu-104a.png',
  'Tu-114': './aircraft/tu-114.png',
  'Tu-124': './aircraft/tu-124.png',
  'Tu-134A': './aircraft/tu-134a.png',
  'Tu-144': './aircraft/tu-144.png',
  'Tu-154B-2': './aircraft/tu-154b-2.png',
  'Tu-154M': './aircraft/tu-154m.png',
  'Tu-204-100': './aircraft/tu-204-100.png',
  'Tu-204-300': './aircraft/tu-204-300.png',
  'Tu-214': './aircraft/tu-214.png',
  'Il-18D': './aircraft/il-18d.png',
  'Il-62M': './aircraft/il-62m.png',
  'Il-76TD': './aircraft/il-76td.png',
  'Il-86': './aircraft/il-86.png',
  'Il-96-300': './aircraft/il-96-300.png',
  'Il-96-400M': './aircraft/il-96-400m.png',
  'Yak-40': './aircraft/yak-40.png',
  'Yak-42D': './aircraft/yak-42d.png',
  'An-24RV': './aircraft/an-24rv.png',
  'An-124-100': './aircraft/an-124-100.png',
  'An-225': './aircraft/an-225.png',
  'AN-2': './aircraft/an-2.png',
  'SSJ-100': './aircraft/ssj-100.png',
  'MC-21-300': './aircraft/mc-21-300.png',
  
  // Regional Props & Jets
  'Shorts-330': './aircraft/shorts-330.png',
  'Shorts-360': './aircraft/shorts-360.png',
  'Let-410UVP': './aircraft/let-410uvp.png',
  'EMB-110': './aircraft/emb-110.png',
  'EMB-120': './aircraft/emb-120.png',
  'YS-11': './aircraft/ys-11.png',
  'Metro-III': './aircraft/metro-iii.png',
  'Do-328': './aircraft/do-328.png',
  'Do-328JET': './aircraft/do-328jet.png',
  'Do-228': './aircraft/do-228.png',
  'BAe-146-100': './aircraft/bae-146-100.png',
  'BAe-146-200': './aircraft/bae-146-200.png',
  'BAe-146-300': './aircraft/bae-146-300.png',
  'Avro-RJ70': './aircraft/avro-rj70.png',
  'Avro-RJ85': './aircraft/avro-rj85.png',
  'Avro-RJ100': './aircraft/avro-rj100.png',
  'Fokker-F27-500': './aircraft/fokker-f27-500.png',
  'Fokker-F28-4000': './aircraft/fokker-f28-4000.png',
  'Fokker-50': './aircraft/fokker-50.png',
  'Fokker-70': './aircraft/fokker-70.png',
  'Fokker-100': './aircraft/fokker-100.png',
  'Saab-340A': './aircraft/saab-340a.png',
  'Saab-340B': './aircraft/saab-340b.png',
  'Saab-2000': './aircraft/saab-2000.png',
  'Jetstream-31': './aircraft/jetstream-31.png',
  'Jetstream-41': './aircraft/jetstream-41.png',
  'DHC-6-300': './aircraft/dhc-6-300.png',
  'DHC-7': './aircraft/dhc-7.png',
  'Dash-8-100': './aircraft/dash-8-100.png',
  'Dash-8-200': './aircraft/dash-8-200.png',
  'Dash-8-300': './aircraft/dash-8-300.png',
  'ATR-42-300': './aircraft/atr-42-300.png',
  'ATR-42-500': './aircraft/atr-42-500.png',
  'ATR-72-200': './aircraft/atr-72-200.png',
  'ATR-72-600': './aircraft/atr-72-600.png',
  
  // Classic/Historic
  'Comet-4C': './aircraft/comet-4c.png',
  'Caravelle-III': './aircraft/caravelle-iii.png',
  'Convair-880': './aircraft/convair-880.png',
  'Convair-990': './aircraft/convair-990.png',
  'VC10': './aircraft/vc10.png',
  'Trident-2E': './aircraft/trident-2e.png',
  'BAC-111-500': './aircraft/bac-111-500.png',
  'DC-10-10': './aircraft/dc-10-10.png',
  'DC-10-15': './aircraft/dc-10-15.png',
  'DC-10-30': './aircraft/dc-10-30.png',
  'DC-10-40': './aircraft/dc-10-40.png',
  'DC-10-30F': './aircraft/dc-10-30f.png',
  'MD-11': './aircraft/md-11.png',
  'MD-11ER': './aircraft/md-11er.png',
  'MD-11CF': './aircraft/md-11cf.png',
  'L-1011-1': './aircraft/l-1011-1.png',
  'L-1011-100': './aircraft/l-1011-100.png',
  'L-1011-200': './aircraft/l-1011-200.png',
  'L-1011-500': './aircraft/l-1011-500.png',
  
  // Obscure/Historic
  'Mercure': './aircraft/mercure.png',
  'VFW-614': './aircraft/vfw-614.png',
  'Concorde': './aircraft/concorde.png',
  'Handley-Page-Herald': './aircraft/handley-page-herald.png',
  'Bristol-Britannia': './aircraft/bristol-britannia.png',
  'Martin-404': './aircraft/martin-404.png',
  'Curtiss-C46': './aircraft/curtiss-c46.png',
  'Lockheed-Constellation': './aircraft/lockheed-constellation.png',
  'Boeing-307': './aircraft/boeing-307.png',
  'Douglas-DC-4': './aircraft/douglas-dc-4.png',
  'Douglas-DC-6B': './aircraft/douglas-dc-6b.png',
  'Douglas-DC-7C': './aircraft/douglas-dc-7c.png',
  'Lockheed-Electra': './aircraft/lockheed-electra.png',
  'Boeing-377': './aircraft/boeing-377.png',
  'Super-Guppy': './aircraft/super-guppy.png',
  'Dreamlifter': './aircraft/dreamlifter.png',
  'Boeing-2707': './aircraft/boeing-2707.png',
  'Spruce-Goose': './aircraft/spruce-goose.png',
  
  // Chinese/Asian
  'C919': './aircraft/c919.png',
  'ARJ21-700': './aircraft/arj21-700.png',
  'Y-10': './aircraft/y-10.png',
  'MA60': './aircraft/ma60.png',
  'N250': './aircraft/n250.png',
  'MRJ90': './aircraft/mrj90.png',
  
  // Business Jets
  'G-IV': './aircraft/g-iv.png',
  'G-V': './aircraft/g-v.png',
  'G550': './aircraft/g550.png',
  'G650': './aircraft/g650.png',
  'G650ER': './aircraft/g650er.png',
  'G700': './aircraft/g700.png',
  'Global-Express': './aircraft/global-express.png',
  'Global-5000': './aircraft/global-5000.png',
  'Global-6000': './aircraft/global-6000.png',
  'Global-7500': './aircraft/global-7500.png',
  'Global-8000': './aircraft/global-8000.png',
  'Falcon-900': './aircraft/falcon-900.png',
  'Falcon-900EX': './aircraft/falcon-900ex.png',
  'Falcon-7X': './aircraft/falcon-7x.png',
  'Falcon-8X': './aircraft/falcon-8x.png',
  'Falcon-10X': './aircraft/falcon-10x.png',
  'Citation-X': './aircraft/citation-x.png',
  'Citation-X-Plus': './aircraft/citation-x-plus.png',
  'Citation-Longitude': './aircraft/citation-longitude.png',
  'Citation-Latitude': './aircraft/citation-latitude.png',
  'Learjet-60': './aircraft/learjet-60.png',
  'Learjet-75': './aircraft/learjet-75.png',
  'Phenom-300E': './aircraft/phenom-300e.png',
  'Praetor-600': './aircraft/praetor-600.png',
  'Legacy-650E': './aircraft/legacy-650e.png',
  'PC-24': './aircraft/pc-24.png',
  'HondaJet-Elite': './aircraft/hondajet-elite.png',
  'Challenger-350': './aircraft/challenger-350.png',
  'Challenger-650': './aircraft/challenger-650.png',
  
  // Military Derivatives
  'KC-135E': './aircraft/kc-135e.png',
  'KC-10A': './aircraft/kc-10a.png',
  'E-3A': './aircraft/e-3a.png',
  'E-4B': './aircraft/e-4b.png',
  'C-5M': './aircraft/c-5m.png',
  'C-17A': './aircraft/c-17a.png',
  'C-130J-30': './aircraft/c-130j-30.png',
  'L-100-30': './aircraft/l-100-30.png',
  'KC-46A': './aircraft/kc-46a.png',
  'P-8A': './aircraft/p-8a.png',
  'C-40A': './aircraft/c-40a.png',
  'VC-25C-Concept': './aircraft/vc-25c-concept.png',
  'Civil-C17': './aircraft/civil-c17.png',
  'C-295': './aircraft/c-295.png',
  'CN-235': './aircraft/cn-235.png',
  
  // Turboprops
  'Beech-1900D': './aircraft/beech-1900d.png',
  'Beech-99': './aircraft/beech-99.png',
  'DHC-3': './aircraft/dhc-3.png',
  'DHC-2': './aircraft/dhc-2.png',
  'Caravan': './aircraft/caravan.png',
  'Caravan-Amphibian': './aircraft/caravan-amphibian.png',
  'King-Air-350': './aircraft/king-air-350.png',
  'PC-12': './aircraft/pc-12.png',
  'TBM-940': './aircraft/tbm-940.png',
  'Quest-Kodiak': './aircraft/quest-kodiak.png',
  'BN-2': './aircraft/bn-2.png',
  'Trislander': './aircraft/trislander.png',
  
  // EOS Legendary/Mythic
  'Sonic-Cruiser': './aircraft/sonic-cruiser.png',
  'MD-12': './aircraft/md-12.png',
  'L-2000': './aircraft/l-2000.png',
  'NMA': './aircraft/nma.png',
  'Stratolaunch': './aircraft/stratolaunch.png',
  'Eclipse-500': './aircraft/eclipse-500.png',
  'Boom-Overture': './aircraft/boom-overture.png',
  
  // Presidential
  'VC-25A': './aircraft/vc-25a.png',
  'VC-25B': './aircraft/vc-25b.png',
  'VC-137C': './aircraft/vc-137c.png',
  'VC-121E': './aircraft/vc-121e.png',
  'VC-54C': './aircraft/vc-54c.png',
  'VC-32A': './aircraft/vc-32a.png',
  
  // Anomalous
  'Quantum-Hopper': './aircraft/quantum-hopper.png',
  'The-Mobius': './aircraft/the-mobius.png',
  'Schrodinger-Jet': './aircraft/schrodinger-jet.png',
  'Negative-One': './aircraft/negative-one.png',
  'Ghost-Freight': './aircraft/ghost-freight.png',
  'The-Perpetual': './aircraft/the-perpetual.png',
  'Blackout': './aircraft/blackout.png',
  'Revenue-Engine': './aircraft/revenue-engine.png',
  'Yesterday': './aircraft/yesterday.png',
  'The-Jinx': './aircraft/the-jinx.png',
  'Infinite-Loop': './aircraft/infinite-loop.png',
  'The-Fold': './aircraft/the-fold.png',
  'Echo-Flight': './aircraft/echo-flight.png',
  'Market-Maker': './aircraft/market-maker.png',
  'Null-Pointer': './aircraft/null-pointer.png',
  'Probability-Storm': './aircraft/probability-storm.png',
  'The-Debt': './aircraft/the-debt.png',
  'Passenger-Zero': './aircraft/passenger-zero.png',
  'Timeline-Fork': './aircraft/timeline-fork.png',
  'The-Anchor': './aircraft/the-anchor.png',
};

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

export function getAircraftImage(model) {
  // 1. Check explicit mapping first
  if (AIRCRAFT_IMAGES[model]) {
    return AIRCRAFT_IMAGES[model];
  }

  // 2. Check if aircraft has image property
  if (AIRCRAFT_DATABASE[model]?.image) {
    return AIRCRAFT_DATABASE[model].image;
  }

  // 3. Auto-generate path from model ID (lowercase, keeps dashes)
  // Handles: "737-200" -> "/aircraft/737-200.png"
  //          "BAe-146-100" -> "/aircraft/bae-146-100.png"
  //          "Fokker-70" -> "/aircraft/fokker-70.png"
  const autoPath = `./aircraft/${model.toLowerCase()}.png`;
  return autoPath;
}

/**
 * Get image path for EOS collectible aircraft
 * @param {string} aircraftId - The collectible aircraft ID (e.g., "ghost-apotheosis")
 * @param {string} rarity - The rarity tier: rare, relic, anomalous, legendary, mythic
 * @returns {string} Path to the image file
 */
export function getCollectibleImagePath(aircraftId, rarity) {
  if (!aircraftId || !rarity) {
    return './aircraft/placeholder.png';
  }
  const rarityFolder = rarity.toLowerCase();
  return `./aircraft/collectibles/${rarityFolder}/${aircraftId.toLowerCase()}.png`;
}

/**
 * Get image for any aircraft (regular or collectible)
 * Checks if aircraft has rarity field to determine if it's a collectible
 * @param {Object|string} aircraft - Aircraft object with id/rarity, or just model string
 * @returns {string} Path to image
 */
export function getAircraftImageSmart(aircraft) {
  // If it's just a string, use regular getAircraftImage
  if (typeof aircraft === 'string') {
    return getAircraftImage(aircraft);
  }

  // PRIORITY 1: Check if database entry has explicit image property
  // This allows collectibles to override the auto-generated path
  const typeKey = aircraft.type || aircraft.model || aircraft.aircraftId || aircraft.id;
  if (typeKey && AIRCRAFT_DATABASE[typeKey]?.image) {
    return AIRCRAFT_DATABASE[typeKey].image;
  }

  // PRIORITY 2: If it's a collectible (has rarity field), use collectible path
  const collectibleRarities = ['rare', 'relic', 'anomalous', 'legendary', 'mythic'];
  if (aircraft.rarity && collectibleRarities.includes(aircraft.rarity.toLowerCase())) {
    // Use aircraftId first (original collectible ID like "747-9"), fall back to model/type
    const id = aircraft.aircraftId || aircraft.model || aircraft.type || aircraft.id;
    return getCollectibleImagePath(id, aircraft.rarity);
  }

  // Otherwise use regular aircraft image
  const model = aircraft.model || aircraft.type || aircraft.id;
  return getAircraftImage(model);
}

export function getAircraftByCategory(category) {
  return Object.entries(AIRCRAFT_DATABASE)
    .filter(([_, ac]) => ac.category === category)
    .map(([id, ac]) => ({ id, ...ac }));
}

export function getPurchasableAircraft() {
  return Object.entries(AIRCRAFT_DATABASE)
    .filter(([_, ac]) => ac.category !== "rare")
    .map(([id, ac]) => ({ id, ...ac }));
}

export function getAircraftByTier(tier) {
  return Object.entries(AIRCRAFT_DATABASE)
    .filter(([_, ac]) => ac.tier === tier && ac.category !== "rare")
    .map(([id, ac]) => ({ id, ...ac }));
}

export function getStarterAircraft() {
  return Object.entries(AIRCRAFT_DATABASE)
    .filter(([_, ac]) => ac.category === "regional" && ac.purchasePrice <= 30000000)
    .map(([id, ac]) => ({ id, ...ac }));
}

// EOS Collectible roll system
// Tiers: RARE (79.9%), RELIC (10%), ANOMALOUS (5%), LEGENDARY (5%), MYTHIC (0.1%)
export function getCollectiblesByRarity(rarity) {
  return Object.entries(AIRCRAFT_DATABASE)
    .filter(([_, ac]) => ac.category === "collectible" && ac.rarity === rarity)
    .map(([id, ac]) => ({ id, ...ac }));
}

export const EOS_ROLL_CHANCES = {
  rare: 0.799,      // 79.9%
  relic: 0.10,      // 10%
  anomalous: 0.05,  // 5%
  legendary: 0.05,  // 5%
  mythic: 0.001     // 0.1%
};

export function rollEOSCollectible() {
  const roll = Math.random();
  let rarity;

  if (roll < 0.001) {
    rarity = 'mythic';
  } else if (roll < 0.051) {
    rarity = 'legendary';
  } else if (roll < 0.101) {
    rarity = 'anomalous';
  } else if (roll < 0.201) {
    rarity = 'relic';
  } else {
    rarity = 'rare';
  }

  const pool = getCollectiblesByRarity(rarity);
  if (pool.length === 0) {
    return { rarity, aircraft: null, id: null };
  }

  const selected = pool[Math.floor(Math.random() * pool.length)];
  return { rarity, aircraft: selected, id: selected.id };
}

// Legacy roll function (backwards compatibility)
export function rollRareAircraft() {
  return rollEOSCollectible();
}

// Stats summary
export function getFleetStats() {
  const aircraft = Object.values(AIRCRAFT_DATABASE);
  const collectibles = aircraft.filter(a => a.category === 'collectible');
  return {
    total: aircraft.length,
    regional: aircraft.filter(a => a.category === 'regional').length,
    narrowbody: aircraft.filter(a => a.category === 'narrowbody').length,
    widebody: aircraft.filter(a => a.category === 'widebody').length,
    collectibles: collectibles.length,
    collectiblesByRarity: {
      rare: collectibles.filter(a => a.rarity === 'rare').length,
      relic: collectibles.filter(a => a.rarity === 'relic').length,
      anomalous: collectibles.filter(a => a.rarity === 'anomalous').length,
      legendary: collectibles.filter(a => a.rarity === 'legendary').length,
      mythic: collectibles.filter(a => a.rarity === 'mythic').length,
    }
  };
}

export default AIRCRAFT_DATABASE;